<template>
  <div
    class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs
      :trail="'投放明细'"
      :subTrail="` > ${operateType}`"
      :href="'/iad_puton/planlist'"></crumbs>
    <div
      class="banxin">
      <div
        class="content-wrapper-body">
        <h2
          class="page-title">
          {{operateType}}</h2>
        <div
          class="basic-info">
          <block
            :blockName="[{name: '基本信息', id: 0, isActive: true}]"></block>
          <div
            class="form-group">
            <div
              class="form-inline">
              <div
                class="form-item require">
                <label
                  class="label">广告ID/名称:</label>
                <el-select
                  v-model="formData.adid"
                  filterable
                  @visible-change="hideDownMenu"
                  placeholder="请选择"
                  :disabled="currentAdId > 0 || currentPutOnId > 0">
                  <el-option
                    v-for="(item, $index) in adList"
                    :key="$index"
                    :label="item.value"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
              <div
                class="form-item require">
                <label
                  class="label">计划名称:</label>
                <el-input
                  v-model="formData.planName"
                  placeholder="限15字以内"
                  maxlength="15"></el-input>
              </div>
              <div
                class="form-item">
                <label
                  class="label">曝光排序:</label>
                <el-radio
                  v-model="formData.exposureSort"
                  :label="0">
                  默认
                </el-radio>
                <el-radio
                  v-model="formData.exposureSort"
                  :label="1">
                  手动排序
                </el-radio>
                <el-input
                  type="text"
                  placeholder="输入数字"
                  style="width: 100px; margin-left: 7px"
                  v-model="formData.orderNum"
                  :disabled="formData.exposureSort !== 1">
                </el-input>
              </div>
            </div>
            <div
              class="form-inline">
              <div
                class="form-item require">
                <label
                  class="label">投放形式:</label>
                <el-select
                  v-model="formData.putonType"
                  placeholder="请选择"
                  @change="customPutOn"
                  ref="cuPutOnChange">
                  <el-option
                    v-for="item in putonTypes"
                    :key="item.PutOnTypeId"
                    :label="item.PutOnTypeName"
                    :value="item.PutOnTypeId">
                  </el-option>
                </el-select>
              </div>
              <div
                class="form-item require">
                <label
                  class="label">广告标签:</label>
                <el-input
                  v-model="tagName"
                  placeholder="选择标签"
                  @focus="tagTrigger = true"
                  :readonly="true"></el-input>
              </div>
              <div
                class="form-item require launchTime">
                <label
                  class="label">投放日期:</label>
                <el-date-picker
                  v-model="formData.putonDate"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div>
            <div
              class="form-inline">
              <div
                class="form-item money-item">
                <label
                  class="label">计划日预算:</label>
                <el-input
                  v-model="formData.planDayBudget"
                  placeholder="请输入"></el-input>
                <span
                  class="money-icon">￥</span>
              </div>
              <div
                class="form-item require">
                <label
                  class="label">广告类型:</label>
                <el-radio
                  v-model="formData.adType"
                  :label="0">
                  广告
                </el-radio>
                <el-radio
                  v-model="formData.adType"
                  :label="1">
                  奖品
                </el-radio>
              </div>
              <div
                class="form-item launchTime require">
                <label
                  class="label">开启时间:</label>
                <el-time-picker
                  is-range
                  v-model="putOnTime"
                  format="HH:mm"
                  value-format="HH:mm"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围">
                </el-time-picker>
              </div>
            </div>
            <div
              class="form-inline">
              <div
                class="form-item require">
                <label
                  class="label">计费类型:</label>
                <el-select
                  v-model="formData.accountType"
                  placeholder="请选择"
                  style="width: 160px; margin-right: 12px;"
                  :disabled="currentPutOnId > 0">
                  <el-option
                    label="请选择"
                    :value="0"></el-option>
                  <el-option
                    label="CPC"
                    :value="1"></el-option>
                  <el-option
                    label="CPA"
                    :value="2"></el-option>
                </el-select>
                <el-checkbox
                  v-model="formData.linkJs">
                  接入JS
                </el-checkbox>
              </div>
              <div
                class="form-item">
                <el-row>
                  <el-col
                    :span="9">
                    <label
                      class="label">开启状态:</label>
                    <el-switch
                      v-model="formData.openS"
                      inactive-color="#ccc"
                      active-color="#5798d7">
                    </el-switch>
                  </el-col>
                  <el-col
                    :span="15">
                    <div
                      class="form-item require">
                      <label
                        class="label">小程序ID:</label>
                      <el-input
                        v-model="formData.MiniAppId"
                        placeholder="请输入小程序ID"
                        style="width: 132px"></el-input>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div
                class="form-item require">
                <label
                  class="label">跳转链接:</label>
                <el-input
                  v-model="formData.putonLink"
                  placeholder="请输入链接"></el-input>
              </div>
            </div>
          </div>
          <div
            class="form-group"
            style="border-top: 1px dashed #dee2e6">
            <div
              class="form-inline"
              style="display: flex; justify-content: flex-start;">
              <div
                class="form-item left require"
                style="width: 516px;">
                <label
                  class="label">广告素材</label>
                <div
                  class="content-wrapper strategy">
                  <multiMateial
                    :materials="materials"
                    @confirmMaterial="confirmMaterial"
                    ref="materials"></multiMateial>
                </div>
              </div>
              <div
                class="form-item right"
                style="width: 716px; margin-left: 34px;">
                <label
                  class="label">广告详情</label>
                <div
                  class="content-wrapper rich-text">
                  <div
                    class="components-container">
                    <div
                      class="editor-container">
                      <UE
                        :defaultMsg.async="formData.defaultMsg"
                        :config="config"
                        :id="ue1"
                        ref="ue"></UE>
                    </div>
                  </div>
                  <div
                    class="important-declare">
                    <textarea
                      cols="30"
                      rows="10"
                      v-model="formData.ImportantStatement"
                      placeholder="重要声明"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="stratergy-group">
          <block
            :blockName="strategyList"
            @changeS="changeStrategy"></block>
          <span
            class="add-strategy"
            @click="openStrategyWindow">新增策略<i
            class="el-icon-circle-plus-outline"></i></span>
          <div
            class="form-group">
            <div
              class="form-inline">
              <div
                class="form-item require">
                <label
                  class="label">操作系统:</label>
                <el-checkbox-group
                  v-model="strategys[strategysIndex].OperatingSystem">
                  <el-checkbox
                    label="ios"></el-checkbox>
                  <el-checkbox
                    label="android"></el-checkbox>
                  <el-checkbox
                    label="其他"></el-checkbox>
                </el-checkbox-group>
              </div>
              <div
                class="form-item require">
                <label
                  class="label">投放地域:</label>
                <span><el-radio
                  v-model="strategys[strategysIndex].AreaRange"
                  :label="0">全部地域</el-radio></span>
                <div
                  style="display: inline-block;">
                  <span
                    @click="areaTrigger = true"><el-radio
                    v-model="strategys[strategysIndex].AreaRange"
                    :label="1"
                    ref="partArea">部分地域</el-radio></span>
                </div>
              </div>
              <div
                class="form-item">
                <label
                  class="label"
                  style="width: 90px">策略开启状态:</label>
                <el-switch
                  v-model="strategys[strategysIndex].IsComplete"
                  inactive-color="#ccc"
                  active-color="#5798d7"></el-switch>
              </div>
            </div>
            <div
              class="form-inline"
              style="justify-content: flex-start;">
              <div
                class="form-item require"
                style="width: 1267px">
                <label
                  class="label"
                  style="width: 100px">小时限流设置</label>
                <div
                  class="limit-config">
                  <div
                    class="data-inline data-header">
                    <div
                      class="tHeader item1">
                      <span
                        class="btnWeek"
                        @mouseenter="weekStatus = true"
                        @mouseleave="weekStatus = false">
                        <span
                          class="btnWeek">
                          <b>{{ strategys[strategysIndex].curWeekDay || '全部' }} <i
                            class="el-icon-arrow-down"
                            style="font-size: 17px"></i></b>
                          <transition
                            name="weekGroup">
                            <div
                              class="week-group"
                              v-show="weekStatus">
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周一'}]"
                                @click="filterWeek('周一', 1)">周一</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周二'}]"
                                @click="filterWeek('周二', 2)">周二</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周三'}]"
                                @click="filterWeek('周三', 3)">周三</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周四'}]"
                                @click="filterWeek('周四', 4)">周四</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周五'}]"
                                @click="filterWeek('周五', 5)">周五</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周六'}]"
                                @click="filterWeek('周六', 6)">周六</span>
                              <span
                                :class="['week-item', {'active': strategys[strategysIndex].curWeekDay === '周日'}]"
                                @click="filterWeek('周日', 7)">周日</span>
                              <span
                                :class="['week-item', {'active': !strategys[strategysIndex].curWeekDay || strategys[strategysIndex].curWeekDay === '全部'}]"
                                @click="filterWeek('全部', 0)">全部</span>
                            </div>
                          </transition>
                        </span>
                      </span>
                    </div>
                    <div
                      class="tHeader item2">
                      投放时间段
                    </div>
                    <div
                      class="tHeader item3">
                      限流类型
                    </div>
                    <div
                      :class="['tHeader', 'item4', {'skew': strategys[strategysIndex].HourLimits && strategys[strategysIndex].HourLimits.length > 5}]">
                      数值
                    </div>
                    <div
                      :class="['tHeader', 'item5', {'skew': strategys[strategysIndex].HourLimits && strategys[strategysIndex].HourLimits.length > 5}]">
                      操作
                    </div>
                  </div>
                  <div
                    class="data-body">
                    <div
                      class="data-inline"
                      v-for="(item, index) in strategys[strategysIndex].HourLimits"
                      :key="item.BusinessId"
                      v-show="hourLimitIsShow(item)">
                      <div
                        class="tBody item1">
                        <el-button
                          size="small"
                          v-for="(sItem, $index) in selectDay(item)"
                          :key="$index"
                          :class="[{'active': sItem.selected}]"
                          @click="weekStatusSwitch($event, item, $index)">
                          {{
                          sItem.name
                          }}
                        </el-button>
                      </div>
                      <div
                        class="tBody item2">
                        <el-select
                          v-model="item[0].BeginHour"
                          @change="timeSelect(item)"
                          placeholder="请选择"
                          style="width: 80px">
                          <el-option
                            v-for="hItem in creatHour24()"
                            :key="hItem.value"
                            :label="hItem.label"
                            :value="hItem.value"
                            :disabled="hItem.value >= item[0].EndHour">
                          </el-option>
                        </el-select>
                        至
                        <el-select
                          v-model="item[0].EndHour"
                          @change="timeSelect(item)"
                          placeholder="请选择"
                          style="width: 80px">
                          <el-option
                            v-for="hItem in creatHour24()"
                            :key="hItem.value"
                            :label="hItem.label"
                            :value="hItem.value"
                            :disabled="hItem.value <= item[0].BeginHour">
                          </el-option>
                        </el-select>
                      </div>
                      <div
                        class="tBody item3">
                        <el-select
                          v-model="item[0].LimitType"
                          placeholder="请选择"
                          style="max-width: 100%;">
                          <el-option
                            v-for="item in limitTypes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <div
                        class="tBody item4">
                        <el-input
                          placeholder="请输入"
                          style="width: 100%;"
                          v-model="item[0].LimitQty"></el-input>
                      </div>
                      <div
                        class="tBody item5">
                        <i
                          class="el-icon-circle-plus-outline"
                          @click="addHourLimit(item, index)"></i>
                        <i
                          class="el-icon-remove-outline"
                          @click="removeHourLimit(item, index)"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-inline">
              <div
                class="form-item require">
                <label
                  class="label">广告位设置:</label>
                <el-radio
                  v-model="strategys[strategysIndex].SourceRange"
                  :label="0"
                  @change="adSetChange">
                  全部
                </el-radio>
                <el-radio
                  v-model="strategys[strategysIndex].SourceRange"
                  :label="1"
                  @change="adSetChange">
                  定投
                </el-radio>
                <el-radio
                  v-model="strategys[strategysIndex].SourceRange"
                  :label="2"
                  @change="adSetChange">
                  屏蔽
                </el-radio>
              </div>
              <div
                class="form-item require money-item">
                <label class="label">计费单价:</label>
                <el-input placeholder="输入单价" v-model="strategys[strategysIndex].AccessPrice" @blur.active="AccessPriceTip(strategysIndex)"></el-input>
                <span class="money-icon">￥</span>
              </div>
              <div
                class="form-item money-item">
                <label
                  class="label">策略日预算:</label>
                <el-input
                  v-model="strategys[strategysIndex].LimitAmount"
                  placeholder="输入日预算"></el-input>
                <span
                  class="money-icon">￥</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="ads-config">
          <div
            class="ads-config-item direct"
            v-show="strategys[strategysIndex].SourceRange === 1">
            <div
              class="leftTopTag">
              定投广告位
            </div>
            <div
              class="search-part">
              <el-input
                placeholder="输入ID或名称"
                style="width: 224px; margin-right: 32px;"
                v-model="pKeyWords"></el-input>
              <el-button
                type="primary"
                size="small"
                @click="filterAds(pKeyWords, 0)">
                搜索
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="openAdsW(0)">
                选择
              </el-button>
              <div
                class="import-ad">
                <input
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="importAd($event, 0)">
                <el-button
                  type="primary"
                  size="small">
                  导入
                </el-button>
              </div>
            </div>
            <div
              class="list-part">
              <div
                class="list-header">
                <span
                  class="list-item item1">广告位ID</span>
                <span
                  class="list-item item2">广告位名称</span>
                <span
                  :class="['list-item', 'item4', {'skew': pList.length > 10}]">操作</span>
              </div>
              <div
                class="list-body">
                <div
                  class="list-tr"
                  v-for="(item, $index) in pList"
                  :key="$index"
                  v-show="adIsShow(item)">
                  <span
                    class="list-item item1">{{ item.id }}</span>
                  <span
                    class="list-item item2"
                    :title="item.name">{{ item.name }}</span>
                  <span
                    class="list-item item4"><i
                    class="el-icon-remove-outline"
                    @click="deleteAds(item.id, 0)"></i></span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ads-config-item sheild"
            v-show="strategys[strategysIndex].SourceRange === 2">
            <div
              class="leftTopTag">
              屏蔽广告位
            </div>
            <div
              class="search-part">
              <el-input
                placeholder="输入ID或名称"
                style="width: 224px; margin-right: 32px;"
                v-model="sKeyWords"></el-input>
              <el-button
                type="primary"
                size="small"
                @click="filterAds(sKeyWords, 1)">
                搜索
              </el-button>
              <el-button
                type="primary"
                size="small"
                @click="openAdsW(1)">
                选择
              </el-button>
              <div
                class="import-ad">
                <input
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  @change="importAd($event, 1)">
                <el-button
                  type="primary"
                  size="small">
                  导入
                </el-button>
              </div>
            </div>
            <div
              class="list-part">
              <div
                class="list-header">
                <span
                  class="list-item item1">广告位ID</span>
                <span
                  class="list-item item2">广告位名称</span>
                <span
                  :class="['list-item', 'item4', {'skew' : sList.length > 10}]">操作</span>
                <!-- <span class="list-item" style="width: 0"></span> -->
              </div>
              <div
                class="list-body">
                <div
                  class="list-tr"
                  v-for="(item, $index) in sList"
                  :key="$index"
                  v-show="adIsShow(item)">
                  <span
                    class="list-item item1">{{ item.id }}</span>
                  <span
                    class="list-item item2"
                    :title="item.name">{{ item.name }}</span>
                  <span
                    class="list-item item4"><i
                    class="el-icon-remove-outline"
                    @click="deleteAds(item.id, 1)"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 限流设置 -->
        <div
          class="zn-limit-edit">
          <label
            class="label">限流设置</label>
          <el-switch
            v-model="strategys[strategysIndex].LimitOpenState"
            active-color="#5798d7"
            inactive-color="#ccc"></el-switch>
          <div
            class="zn-limit-time">
            <div
              class="search-pad">
              <div
                class="limit-search-inp">
                <el-input
                  v-model="limitSearch"
                  placeholder="请输入ID或名称"
                  @input="filterCurrentAdLimit"></el-input>
              </div>
              <el-button
                size="small"
                type="primary"
                @click="editLimit">
                编辑限流
              </el-button>
            </div>
            <div
              class="ads-config">
              <div
                class="list-part">
                <div
                  class="list-header">
                  <span
                    class="list-item item1">广告位ID</span>
                  <span
                    class="list-item item2">广告位名称</span>
                  <span
                    class="list-item item4">投放时间段</span>
                  <span
                    class="list-item item4">限流类型</span>
                  <span
                    class="list-item item4">数值</span>
                  <span
                    class="list-item item4">操作</span>
                </div>
                <div
                  class="list-body">
                  <div
                    class="list-tr"
                    v-for="(item, $index) in currentAdLimit"
                    v-show="adLimitIshow(item)">
                    <span
                      class="list-item item1">{{item.SourceId}}</span>
                    <span
                      class="list-item item2">{{item.SourceName}}</span>
                    <div
                      class="list-item item2">
                      <el-select
                        v-model="item.BeginHour"
                        @change="adLimitChange"
                        placeholder="请选择"
                        style="width: 80px">
                        <el-option
                          v-for="hItem in creatHour24()"
                          :key="hItem.value"
                          :label="hItem.label"
                          :value="hItem.value"
                          :disabled="hItem.value >= item.EndHour">
                        </el-option>
                      </el-select>
                      至
                      <el-select
                        v-model="item.EndHour"
                        @change="adLimitChange"
                        placeholder="请选择"
                        style="width: 80px">
                        <el-option
                          v-for="hItem in creatHour24()"
                          :key="hItem.value"
                          :label="hItem.label"
                          :value="hItem.value"
                          :disabled="hItem.value <= item.BeginHour">
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      class="list-item item2">
                      <el-select
                        v-model="item.LimitType"
                        placeholder="请选择"
                        style="width: 80px">
                        <el-option
                          v-for="tItem in adLimitTypes"
                          :key="tItem.value"
                          :label="tItem.label"
                          :value="tItem.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div
                      class="list-item item2">
                      <el-input
                        v-model="item.LimitQty"
                        placeholder="请输入"></el-input>
                    </div>
                    <span
                      class="list-item item4"><i
                      class="el-icon-remove-outline"
                      @click="removeAdLimitHour($index)"></i></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="footer">
        <div
          class="btn-group">
          <el-button
            type="default"
            @click="backVerif = true">
            返回
          </el-button>
          <el-button
            type="primary"
            @click="saveStrategyInfo"
            :disable="saveBtnDisabled"
            :loading="saveBtnDisabled">
            确定
          </el-button>
        </div>
      </div>
      <!-- 广告标签 -->
      <el-dialog
        title="广告标签"
        :visible.sync="tagTrigger"
        class="tagWindow"
        @close="closeTagW(0)">
        <div>
          <div
            class="industry-tag-header">
            <div
              class="tab-btn">
              <span
                :class="['tab-btn-item', 'tab-btn-ind', {'active': tagType === 0}]"
                @click="switchTag(0)">行业</span>
              <span
                :class="['tab-btn-item', 'tab-btn-type', {'active': tagType === 1}]"
                @click="switchTag(1)">品类</span>
            </div>
          </div>
          <div
            class="industry-tag-body">
            <div
              :class="['selection-group', {'mouseon': tagIndex === index}]"
              v-for="(item, index) in tagDataActive"
              :key="item.LabelId"
              @mouseenter="showSubTag(index)"
              @mouseleave="tagIndex = -1">
              <label
                class="checkbox-item industry-trunk">
                <input
                  type="checkbox"
                  :id="item.LabelId"
                  :name="item.LabelName"
                  :checked="tagArr.indexOf(String(item.LabelId)) > -1"
                  @change="pTagStatusSwitch(item)">
                <span>{{ item.LabelName }}</span>
              </label>
              <div
                class="industry-branch">
                <label
                  class="checkbox-item"
                  v-for="tItem in item.subTags"
                  :key="tItem.LabelId">
                  <input
                    @change="subTagStatusSwitch(item, tItem)"
                    type="checkbox"
                    :id="tItem.LabelId"
                    :name="tItem.LabelName"
                    :checked="tagArr.indexOf(String(tItem.LabelId)) > -1">
                  <span>{{ tItem.LabelName }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- 自定义行业标签 -->
        <el-dialog
          width="450px"
          title="自定义标签"
          :visible.sync="addLableDialog"
          append-to-body
          @close="addLable.labelName = ''">
          <el-form
            :model="addLable">
            <el-form-item
              label="自定义行业标签："
              label-width="35%"
              class="cancel-mrginb">
              <el-input
                v-model="addLable.labelName"
                auto-complete="off"
                placeholder="请输入行业标签（限6个字）"></el-input>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer">
            <el-button
              @click="addLableDialog = false">
              取
              消
            </el-button>
            <el-button
              type="primary"
              @click="canfrimAddLabel">
              确
              定
            </el-button>
          </div>
        </el-dialog>
        <div
          slot="footer"
          class="dialog-footer">
          <span
            class="custom-label el-icon-circle-plus-outline"
            @click="addLableDialog = true"> 自定义</span>
          <el-button
            @click="closeTagW(0)">
            取
            消
          </el-button>
          <el-button
            type="primary"
            @click="closeTagW(1)">
            确
            定
          </el-button>
        </div>
      </el-dialog>
      <!-- 新增策略 -->
      <el-dialog
        title="新增策略"
        :visible.sync="strategyTrigger"
        class="addStrategy"
        @open="openStrategyW">
        <el-form>
          <el-form-item
            label="策略类型"
            :label-width="formLabelWidth">
            <el-radio
              v-model="addStrtegy.strategyType"
              :label="1">
              新增
            </el-radio>
            <el-radio
              v-model="addStrtegy.strategyType"
              :label="2">
              复制
            </el-radio>
            <el-select
              placeholder="请选择策略"
              style="margin-left: 30px"
              v-model="addStrtegy.strategyItem"
              :disabled="addStrtegy.strategyType === 1">
              <el-option
                v-for="(item, $index) in strategys"
                :key="$index"
                :label="item.AdTaskName"
                :value="$index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="新策略名称"
            :label-width="formLabelWidth"
            class="cancel-mrginb">
            <el-input
              placeholder="请输入（限6字）"
              maxlength="6"
              style="width: 373px"
              v-model="addStrtegy.strategyName"></el-input>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="strategyTrigger = false">
            取
            消
          </el-button>
          <el-button
            type="primary"
            @click="appendStrategy">
            确
            定
          </el-button>
        </div>
      </el-dialog>
      <!-- 投放地域 -->
      <el-dialog
        title="投放地域"
        :visible.sync="areaTrigger"
        class="areaWindow"
        @open="openAreaW"
        @close="areaTrigger = false">
        <div
          class="putonArea">
          <div
            class="region"
            v-for="aItem in areaList"
            :key="aItem.Areacode">
            <label
              class="check-item">
              <input
                type="checkbox"
                :checked="aItem.selected"
                @change="clickAreaItem(aItem)">
              <span
                class="area-name"
                :title="aItem.AreaName">{{ aItem.AreaName }}</span>
            </label>
            <div
              class="provinces-group">
              <div
                :class="['provinces', {'mouseon': activeAreaCode === pItem.Areacode}]"
                v-for="pItem in aItem.subProvinces"
                :key="pItem.Areacode"
                @mouseenter="showSubCities(pItem)"
                @mouseleave="hideSubCities">
                <label
                  class="check-item">
                  <input
                    type="checkbox"
                    :checked="pItem.selected"
                    @change="clickProvinceItem(aItem, pItem)">
                  <span
                    class="area-name"
                    :title="pItem.AreaName">{{ pItem.AreaName }}</span>
                </label>
                <div
                  class="cities-group">
                  <div
                    class="cities"
                    v-for="cItem in pItem.subCities"
                    :key="cItem.Areacode">
                    <label
                      class="check-item">
                      <input
                        type="checkbox"
                        :checked="cItem.selected"
                        @change="clickCityItem(aItem, pItem, cItem)">
                      <span
                        class="area-name"
                        :title="cItem.AreaName">{{ cItem.AreaName }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="closeAreaW(0)">
            取 消
          </el-button>
          <el-button
            type="primary"
            @click="closeAreaW(1)">
            确 定
          </el-button>
        </div>
      </el-dialog>
      <!-- 广告位弹窗 -->
      <transition
        name="adsW">
        <div
          class="ads-sheild"
          v-if="adsWS">
          <div
            class="ads-frame">
            <div
              class="frame-header">
              <h4>
                选择广告位</h4>
              <div
                class="search-box">
                <i
                  class="icon el-icon-search"></i>
                <input
                  type="text"
                  id="search-frame"
                  v-model="mediaKeyWord"
                  @input="searchMedia">
              </div>
              <span
                class="el-icon-close closeFrame"
                @click="closeAdsW(0)"></span>
            </div>
            <div
              class="frame-body">
              <ul
                class="clearfloat media-list"
                id="sourceList">
                <li
                  v-for="(item, $index) in copyAdsList"
                  :key="$index"
                  v-if="!item.isHide">
                  <input
                    :class="['btn', 'btn-default', 'media-item', {'selected': item.isSelected}]"
                    :title="item.SourceName"
                    type="button"
                    :value="item.SourceName"
                    :sourceid="item.SourceId"
                    @click="switchAdsStatus(item, $index)">
                </li>
              </ul>
            </div>
            <div
              class="frame-footer">
              <div
                class="btn-box">
                <el-button
                  type="default"
                  @click="closeAdsW(0)">
                  取 消
                </el-button>
                <el-button
                  type="primary"
                  @click="closeAdsW(1)">
                  确 认
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 自定义投放形式 -->
      <el-dialog
        title="自定义投放形式"
        :visible.sync="customAdDialog"
        width="450px"
        @close="customAdClose">
        <el-form
          :model="addCustomAd">
          <el-form-item
            label="自定义投放形式："
            label-width="33%"
            class="cancel-mrginb">
            <el-input
              v-model="addCustomAd.putOnType"
              auto-complete="off"
              placeholder="请输入投放形式(限10个字)"
              ref="customAd"></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="cancelPutOnType">取 消</el-button>
          <el-button
            type="primary"
            @click="savePutOnType">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑预算 -->
      <el-dialog
        title="编辑预算"
        :visible.sync="budgetTrigger"
        width="450px">
        <el-form>
          <el-form-item
            label="输入预算："
            label-width="27%"
            class="cancel-mrginb">
            <el-input
              placeholder="请输入"
              v-model="budgetConfig.money"
              maxlength="9"></el-input>
          </el-form-item>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="budgetTrigger = false">
            取 消
          </el-button>
          <el-button
            type="primary"
            @click="setBudget">
            确 定
          </el-button>
        </div>
      </el-dialog>
      <!-- 限流设置 -->
      <el-dialog
        title="限流设置"
        :visible.sync="limitTrigger"
        width="800px"
        class="el-dialog__body_pd0 zn-limit-time-dialog"
        @open="openAreaW"
        @close="limitTrigger = false"
        center>
        <div
          class="limit-hour-head">
          <span
            class="item ad-hour">投放时间段</span>
          <span
            class="item limit-type">限流类型</span>
          <span
            class="item limit-number">数值</span>
          <span
            class="item limit-operation">操作</span>
        </div>
        <div
          class="limit-hour-body">
          <div
            class="limit-hour-row"
            v-for="(item, $index) in adSLimitHour">
            <div
              class="item ad-hour">
              <el-select
                v-model="item.BeginHour"
                @change=""
                placeholder="请选择"
                style="width: 80px">
                <el-option
                  v-for="hItem in creatHour24()"
                  :key="hItem.value"
                  :label="hItem.label"
                  :value="hItem.value"
                  :disabled="hItem.value >= item.EndHour">
                </el-option>
              </el-select>
              至
              <el-select
                v-model="item.EndHour"
                @change=""
                placeholder="请选择"
                style="width: 80px">
                <el-option
                  v-for="hItem in creatHour24()"
                  :key="hItem.value"
                  :label="hItem.label"
                  :value="hItem.value"
                  :disabled="hItem.value <= item.BeginHour">
                </el-option>
              </el-select>
            </div>
            <div
              class="item limit-type">
              <el-select
                v-model="item.LimitType"
                placeholder="请选择"
                style="width: 80px">
                <el-option
                  v-for="tItem in adLimitTypes"
                  :key="tItem.value"
                  :label="tItem.label"
                  :value="tItem.value">
                </el-option>
              </el-select>
            </div>
            <div
              class="item limit-number">
              <el-input
                v-model="item.LimitQty"
                placeholder="请输入数值"></el-input>
            </div>
            <div
              class="item limit-operation">
              <i
                class="el-icon-circle-plus-outline"
                @click="addAdLimitHour"></i>
              <i
                class="el-icon-remove-outline"
                @click="removeAdLimitHourPop($index)"
                v-if="$index !== 0"></i>
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="closeLimitW(0)">
            取
            消
          </el-button>
          <el-button
            type="primary"
            @click="closeLimitW(1)">
            确
            定
          </el-button>
        </div>
      </el-dialog>
      <!-- 返回提示 -->
      <el-dialog
        title="离开此页面？"
        :visible.sync="backVerif"
        width="400px">
        <span>系统将不会保存您所做的修改。</span>
        <span
          slot="footer"
          class="dialog-footer">
          <el-button
            @click="backVerif = false">取 消</el-button>
          <el-button
            type="primary"
            @click="backPrevPage">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script
  type="text/ecmascript-6">
  // 面包屑
  import crumbs from "../public/crumbs/crumbs";
  // 标题
  import block from "../public/edit-plan-sub/block";
  // 添加素材
  import multiMateial from "../public/edit-plan-sub/multiMateial";
  // 富文本编辑器
  import UE from "../public/edit-plan-sub/ue.vue";
  // 工具函数
  import {
    parser,
    verifLink,
    verifNumber,
    verifFloat,
    toDou,
    delRepeat
  } from "common/js/util";
  import {ZStream} from "common/js/jszip";
  import {XLSX} from "common/js/myexcel";
  // api
  import {
    getStrategyInfo,
    getAdList,
    getPutonType,
    getLabelList,
    getAreaList,
    getMediaList,
    savePutOn,
    savePutOnType,
    userDefined
  } from "api/strategy";

  // 所有策略最大小时限流条数
  const maxLimit = 120;

  export default {
    data() {
      return {
        // 当前广告ID
        currentAdId: 0,
        // 当前拷贝ID
        currentCopyId: 0,
        // 当前投放ID
        currentPutOnId: 0,
        // 当前路径位置
        operateType: "添加计划",
        // 策略数据
        strategyInfo: {},
        // 广告列表
        adList: [],
        // 过滤后的广告列表
        filterAdList: [],
        // 页面数据收集
        formData: {},
        // 投放形式列表
        putonTypes: [],
        // 广告标签
        tagName: "",
        // 广告素材
        materials: [],
        //
        materialsMin: [],
        //
        mediaKeyWord: "",
        // 富文本编辑框配置参数
        config: {
          initialFrameWidth: null,
          initialFrameHeight: 177
        },
        // 自定义投放形式弹窗显示状态
        customAdDialog: false,
        // 自定义弹窗取值
        addCustomAd: {
          oldAdid: 0,
          putOnType: ""
        },
        // 添加行业标签弹窗显示状态
        addLableDialog: false,
        // 添加行业标签取值
        addLable: {
          labelName: ""
        },
        ue1: "ue1",
        // 广告标签
        tagTrigger: false,
        // 广告标签类型
        tagType: 0,
        //
        tagIndex: -1,
        // 标签名
        tagName: "",
        //
        tagArr: [],
        // 广告标签列表
        tagDataActive: [],
        //
        tagData: {
          industries: [],
          type: []
        },
        // 计费类型禁止状态
        cannotChange: false,
        // 当前策略位置
        strategysIndex: 0,
        // 策略
        strategys: [],
        // 新增策略弹窗状态
        strategyTrigger: false,
        // 限流类型
        limitTypes: [
          {
            value: -1,
            label: "请选择"
          },
          {
            value: 0,
            label: "预算"
          },
          {
            value: 1,
            label: "每小时预算"
          },
          {
            value: 2,
            label: "曝光"
          },
          {
            value: 3,
            label: "每小时曝光"
          }
        ],
        // 广告位限流类型
        adLimitTypes: [
          {
            value: -1,
            label: "请选择"
          },
          {
            value: 0,
            label: "预算"
          },
          {
            value: 2,
            label: "曝光"
          }
        ],
        formLabelWidth: "120px",
        // 新增策略
        addStrtegy: {
          // 新增策略类型（1:新增，2:复制）
          strategyType: 1,
          // 复制哪个策略
          strategyItem: 1,
          // 策略名称
          strategyName: ""
        },
        // 投放地域弹窗显示状态
        areaTrigger: false,
        // 投放地域列表
        areaList: [],
        //
        activeAreaCode: -1,
        // 广告位弹窗显示状态
        adsWS: false,
        pKeyWords: "",
        sKeyWords: "",
        sList: [],
        pList: [],
        adsList: [],
        putonAreaIdArr: [],
        // 所有广告位
        allAdsList: [],
        // 复制广告位列表
        copyAdsList: [],
        // 编辑预算弹窗
        budgetTrigger: false,
        budgetConfig: {
          money: 0
        },
        // 是否禁止保存按钮
        saveBtnDisabled: false,
        // 返回提示弹窗显示状态
        backVerif: false,
        // 按天筛选弹窗显示状态
        weekStatus: false,
        // 当前天
        curWeekDay: "全部",
        // 小时限流弹窗显示状态
        limitTrigger: false,
        // 广告位限流搜索
        limitSearch: "",
        // 是小时限流打开的弹窗
        limitTimeStatus: false,
        // 广告位限流时间段
        adSLimitHour: [],
        // 选中的设置小时限流的广告位
        selectedAdsLimit: [],
        putOnTime: ""
      };
    },
    computed: {
      // 策略列表
      strategyList() {
        let strategys = this.strategys;
        let strategysList = [];
        for (let i = 0; i < strategys.length; i++) {
          let item = strategys[i];
          strategysList.push({
            name: item.AdTaskName,
            isActive: this.strategysIndex === i
          });
        }
        return strategysList;
      },
      // 当前策略的广告位限流
      currentAdLimit() {
        let strategys = JSON.parse(JSON.stringify(this.strategys));
        this.$set(this, "strategys", strategys);

        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        // 限流时间段
        let limitTime = strategyActive.SourceLimits;
        // 创建广告位字典
        let adDictionary = {};
        this.copyAdsList.map(ad => {
          adDictionary[ad.SourceId] = ad;
        });
        // 有效时间限流
        let filterLimitTime = [];
        for (let i = 0; i < limitTime.length; i++) {
          let item = limitTime[i];
          if (item.BeginHour || item.EndHour) {
            adDictionary[item.SourceId] &&
            (item.SourceName = adDictionary[item.SourceId].SourceName);
            filterLimitTime.push(item);
          }
        }
        return filterLimitTime;
      }
    },
    components: {
      crumbs,
      block,
      multiMateial,
      UE
    },
    methods: {
      // 计费单价高额提示
      AccessPriceTip(index) {
        let value = this.strategys[index].AccessPrice;
        if(value && value >= 2) {
          this.$alert(`您此次设置的计费单价为 ${value} 元，是否确认此单价？`, '计费单价', {
            confirmButtonText: '确定'
          });
        }
      },
      // 自定义投放形式
      customPutOn(id) {
        // -1代表自定义
        if (Number(id) !== -1) {
          this.addCustomAd.oldPutonType = id;
          return;
        }
        // 显示自定义弹窗
        this.customAdDialog = true;
        // 选择自定义后续操作
        this.$nextTick(() => {
          // 弹窗显示后让广告ID下拉列表失焦
          this.$refs.cuPutOnChange.blur();
          // 自定义广告名称默认获取焦点
          this.$refs.customAd.focus();
        });
      },
      // 添加自定义广告投放形式
      savePutOnType() {
        let addCustomAd = this.addCustomAd;
        addCustomAd.putOnType = addCustomAd.putOnType.trim();
        if (addCustomAd.putOnType.length > 10) {
          this.$message.error("自定义投放形式最多不能超过10个字");
          return;
        }
        savePutOnType(addCustomAd).then(res => {
          if (res.success) {
            this.putonTypes.push({
              PutOnTypeId: res.id,
              PutOnTypeName: this.addCustomAd.putOnType
            });
            // 选中新增广告
            this.formData.putonType = res.id;
            // 关闭自定义弹窗
            this.customAdDialog = false;
            // 新增投放形式
            this.addCustomAd.oldPutonType = res.id;
            return;
          }
          this.$message.error(res.msg);
        });
      },
      // 取消自定义广告投放形式
      cancelPutOnType() {
        // 设置为上一次选中值
        this.formData.putonType = this.addCustomAd.oldPutonType;
        // 关闭自定义弹窗
        this.customAdDialog = false;
      },
      // 自定义广告投放形式监听
      customAdClose() {
        if (this.formData.putonType === -1) {
          this.formData.putonType = this.addCustomAd.oldPutonType;
        }
        this.addCustomAd.putOnType = "";
      },
      // 下拉消失时还原列表
      hideDownMenu() {
        this.filterAdList = this.adList;
      },
      // 添加行业标签
      canfrimAddLabel() {
        let params = this.addLable;
        params.labelName = params.labelName.trim();
        if (params.labelName.length > 6) {
          this.$message.error("行业标签最多不能超过6个字");
          return;
        }
        params.typeId = this.tagType;

        userDefined(params).then(res => {
          if (res.success) {
            let newLabel = {
              LabelId: res.id,
              LabelType: params.typeId,
              LabelName: params.labelName,
              ParentLabelId: 0,
              subTags: []
            };
            // 当前类型同步新增加标签
            this.tagDataActive.unshift(newLabel);
            // 给tagList同步新增加标签
            this.tagList.push(newLabel);
            // 默认选中
            this.tagArr.push(String(res.id));
            // 关闭自定义行业标签弹窗
            this.addLableDialog = false;
            // 清空自定义行业标签名
            params.labelName = "";
            return;
          }
          this.$message.error(res.msg);
        });
      },
      initInterface() {
        // 获取广告列表
        this.getAdList();
        // 获取投放形式
        this.getPutonType();
        // 获取广告标签
        this.getLabelList();
        // 获取城市列表
        this.getAreaList();
        // 获取广告位列表
        this.getAllActivities();
      },
      // 设置初始值
      setFromData(data) {
        let formData = {
          adid: data.AdId,
          planName: data.AdTaskName,
          putonLink: data.AdrLink,
          MiniAppId: data.MiniAppId,
          AppPlatform: data.AppPlatform,
          putonType: data.PutOnTypeId,
          putonid: this.currentPutOnId,
          adTag: data.LabelIds,
          exposureSort: data.OrderType,
          orderNum: data.OrderNum,
          planDayBudget: data.LimitAmount || "",
          adType: data.AwardType,
          putonDate: [data.ValidityDateStart, data.ValidityDateEnd],
          accountType: data.ChargeType || 0,
          openS: data.IsComplete === 0 ? true : false,
          linkJs: data.JSFlag === 0 ? false : true,
          ImportantStatement: data.ImportantStatement,
          defaultMsg: data.GraphicText
        };

        function getPutTime(strTime) {
          if (strTime) {
            let date = new Date();
            let y = date.getFullYear();
            let M = date.getMonth();
            let D = date.getDate();

            let newDate = new Date();
            newDate.setFullYear(y, M, D);
            let t = strTime.split(":");
            newDate.setHours(toDou(t[0]), t[1], t[2], 0);
            return newDate;
          }
          return "";
        }

        let validityTimeStart = getPutTime(data.ValidityTimeStart);
        let validityTimeEnd = getPutTime(data.ValidityTimeEnd);
        validityTimeStart &&
        validityTimeEnd &&
        (this.putOnTime = [validityTimeStart, validityTimeEnd]);

        this.materials = data.Materials.map(item => {
          let openState = item.OpenState;
          item.OpenState = !!openState;
          return item;
        });
        // 同步初次选中投放形式
        this.addCustomAd.oldPutonType = formData.putonType;

        // 删除首位字符
        const trimChar = str => {
          return str ? str.substring(1, str.length - 1) : "";
        };
        // 投放地区类型转换
        data.PutOnAreaId = trimChar(data.PutOnAreaId).split(",");

        for (let i = 0, strategys = data.Strategys; i < strategys.length; i++) {
          let item = strategys[i];
          // 投放系统
          let OperatingSystem = trimChar(item.OperatingSystem);
          item.OperatingSystem = OperatingSystem
            ? OperatingSystem.replace("h5", "其他").split(",")
            : [];
          // 屏蔽广告位转换
          let ShieldSourceId = trimChar(item.ShieldSourceId);
          ShieldSourceId = ShieldSourceId ? ShieldSourceId.split(",") : [];
          item.ShieldSourceId = ShieldSourceId.map(i => {
            return Number(i);
          });
          // 定投广告位转换
          let PutOnSourceId = trimChar(item.PutOnSourceId);
          PutOnSourceId = PutOnSourceId ? PutOnSourceId.split(",") : [];
          item.PutOnSourceId = PutOnSourceId.map(i => {
            return Number(i);
          });

          item.allAdsLimit = [];
          item.sourceAdsLimit = [];
          item.shieldAdsLimit = [];
          // 全部
          let SourceLimits = JSON.parse(item.SourceLimits);

          let sourceLimits = [];
          for (let j = 0; j < SourceLimits.length; j++) {
            if (SourceLimits[j].LimitQty === -1) {
              SourceLimits[j].LimitQty = "";
            }
            if (SourceLimits[j].hasOwnProperty("BeginHour")) {
              sourceLimits.push(SourceLimits[j]);
            }
          }
          // 定投广告位转换
          item.SourceLimits = sourceLimits;
          // 转换小时限流数据
          item.HourLimits = JSON.parse(item.HourLimits);
          // 转换策略开启状态（0开启1关闭）转换为前台需要的（0关闭1开启）
          item.IsComplete =
            typeof item.IsComplete === "boolean" || item.IsComplete === 0
              ? true
              : false;
          // 广告位限流设置（0关闭1开启）
          item.LimitOpenState =
            (typeof item.LimitOpenState === "boolean" && item.LimitOpenState) ||
            item.LimitOpenState === 1
              ? true
              : false;
          // 策略日预算为0时转换为空(策略日预算为空时后端返回0)
          item.LimitAmount =
            Number(item.LimitAmount) === 0 ? "" : item.LimitAmount;
          // 小时限流“数值”类型转换
          let hourLimits = item.HourLimits;
          for (let k = 0; k < hourLimits.length; k++) {
            for (let j = 0, row = hourLimits[k]; j < row.length; j++) {
              let hour = row[j];
              for (let key in hour) {
                if (hour.LimitQty === -1) {
                  hour.LimitQty = "";
                }
              }
            }
          }

          // 同步策略数据
          this.$set(this, "strategys", data.Strategys);
        }

        this.formData = formData;
      },
      // 获取策略信息
      getStrategyInfo(params, copyid, putonid) {
        getStrategyInfo(params).then(res => {
          let data = null;
          // 保留原始数据
          if (res.status !== 0) {
            data = Object.assign({}, res.data);
            this.initInterface();
          } else {
            data = this.defaultData();
            this.$notify({
              title: "错误",
              message: "计划ID无效，请验证是否有此计划",
              type: "error",
              duration: 0
            });
          }

          // 策略不存在时添加一个默认策略
          if (!data.Strategys.length) {
            data.Strategys = [this.newStrategy("默认策略")];
            this.$notify({
              title: "警告",
              message: "未获取到策略信息,已为您创建了一个默认策略！",
              type: "warning"
            });
          }

          // 复制计划素材id重制为零
          if (copyid > 0 && putonid === 0) {
            for (
              let i = 0, materials = data.Materials;
              i < materials.length;
              i++
            ) {
              let item = materials[i];
              item.MaterialId = 0;
            }
            for (
              let i = 0, strategys = data.Strategys;
              i < strategys.length;
              i++
            ) {
              let item = strategys[i];
              item.PutOnId = 0;
            }
          }
          // 同步策略信息
          this.strategyInfo = data;
          // 同步初始值
          this.setFromData(data);
        });
      },
      // 新策略
      newStrategy(AdTaskName, isCreat) {
        return {
          AdTaskName,
          PutOnId: 0,
          AreaRange: 0,
          PutOnAreaId: "",
          IsComplete: true,
          SourceRange: 0,
          AccessPrice: "",
          LimitAmount: "",
          HourLimits: isCreat
            ? [this.defaultTimeStage()]
            : JSON.stringify([this.defaultTimeStage()]),
          SourceLimits: isCreat ? [] : "[]",
          ShieldSourceId: isCreat ? [] : "",
          PutOnSourceId: isCreat ? [] : "",
          OperatingSystem: isCreat ? [] : "",
          LimitOpenState: isCreat ? false : 0,
          allAdsLimit: [],
          shieldAdsLimit: [],
          sourceAdsLimit: []
        };
      },
      // 策略默认数据
      defaultData(adid) {
        let date = new Date();
        // 开始时间默认为当天
        let startTime = `${date.getFullYear()}-${toDou(
          date.getMonth() + 1
        )}-${toDou(date.getDate())} 00:00:00`;
        return {
          AdId: adid > 0 ? adid : null,
          AdTaskName: "",
          AdrLink: "",
          MiniAppId: "",
          AppPlatform: 1,
          PutOnTypeId: "",
          LabelIds: "",
          OrderType: 0,
          OrderNum: 0,
          LimitAmount: "",
          AwardType: 0,
          ValidityDateStart: startTime,
          ValidityDateEnd: "",
          ChargeType: "",
          JSFlag: 0,
          IsComplete: 0,
          GraphicText: "",
          ImportantStatement: "",
          Materials: [],
          Strategys: [this.newStrategy("默认策略")]
        };
      },
      // 初始化策略
      initStrategy() {
        // 获取当前链接中的参数
        let oParams = parser(location.search);
        // oParams.putonid = 78677;
        // 当前路径位置
        let operateType = "";
        // 收集参数
        let params = {};
        // 投放ID
        let putonid = Number(oParams.putonid);
        // 策略复制ID
        let copyid = Number(oParams.copyid);
        // 广告ID
        let adid = Number(oParams.adid);

        // 代表编辑
        if (putonid > 0) {
          this.currentPutOnId = putonid;
          // 编辑计划
          operateType = "编辑计划";
          // 同步投放ID
          params.putonid = putonid;
        } else {
          // 代表是被复制的
          if (copyid > 0) {
            this.currentCopyId = copyid;
            // 复制计划
            operateType = "复制计划";
            // 同步复制ID
            params.copyid = copyid;
          } else {
            // 代表新增
            this.currentAdId = adid;
            // 添加计划
            operateType = "添加计划";
            // 同步状态为false
            putonid = 0;
            copyid = 0;
          }
        }

        let data = this.defaultData(adid);
        this.strategyInfo = data;
        // 同步初始值
        this.setFromData(data);
        // 设置当前路径位置
        this.operateType = operateType;
        // 新增状态
        if (putonid || copyid) {
          // 获取策略信息
          this.getStrategyInfo(params, copyid, putonid);
        } else {
          this.initInterface();
        }
      },
      // 获取广告列表
      getAdList() {
        getAdList().then(res => {
          this.adList = res.map(item => {
            item.value = `${item.Id}-${item.value}`;
            return item;
          });
        });
      },
      // 获取投放形式列表
      getPutonType() {
        getPutonType().then(res => {
          // 添加自定义选项
          res = [
            {
              PutOnTypeId: -1,
              PutOnTypeName: "自定义"
            }
          ].concat(res);
          this.putonTypes = res;
        });
      },
      // 获取标签数据
      getLabelList() {
        getLabelList().then(res => {
          this.tagList = res;
          this.tagList.forEach((item, index) => {
            if (item.ParentLabelId === 0 && item.LabelType === 0) {
              item.subTags = [];
              this.tagData.industries.push(item);
            } else if (item.ParentLabelId === 0 && item.LabelType === 1) {
              item.subTags = [];
              this.tagData.type.push(item);
            }
          });
          this.tagList.forEach((item, index) => {
            if (item.ParentLabelId !== 0 && item.LabelType === 0) {
              this.tagData.industries.forEach((iItem, iIndex) => {
                if (iItem.LabelId === item.ParentLabelId) {
                  iItem.subTags.push(item);
                }
              });
            } else if (item.ParentLabelId !== 0 && item.LabelType === 1) {
              this.tagData.type.forEach((tItem, tIndex) => {
                if (tItem.LabelId === item.ParentLabelId) {
                  tItem.subTags.push(item);
                }
              });
            }
          });
          this.switchTag();
          this.filterTagNameById();
        });
      },
      // 切换标签
      switchTag(t = 0) {
        this.tagType = t;
        if (t === 0) {
          this.tagDataActive = this.tagData.industries;
        } else {
          this.tagDataActive = this.tagData.type;
        }
      },
      // 通过id筛选标签名称
      filterTagNameById() {
        this.tagArr = this.formData.adTag.split(',')
        this.tagNameArr = []
        this.tagArr.pop()
        this.tagArr.shift()
        let flag = 0;
        let flagArr = [];
        this.tagList.some((item, index) => {
          this.tagArr.forEach((dItem, dIndex) => {
            if (item.LabelId == dItem) {
              this.tagNameArr.push(item.LabelName);
              flag++;
              flagArr.push(item.LabelId);
            }
          })
        })
        if(flag > 0) {
          this.tagName = this.tagNameArr.join(',');
          this.formData.adTag = ',' + flagArr.join(',') + ',';
        } else {
          this.tagName = '';
          this.formData.adTag = '';

        }
      },
      // 鼠标悬停 显示子标签
      showSubTag(index) {
        if (this.tagDataActive[index].subTags.length > 0) {
          this.tagIndex = index;
        }
      },
      // 子标签状态切换
      subTagStatusSwitch(parent, sub) {
        const id1 = String(parent.LabelId);
        const id2 = String(sub.LabelId);
        if (this.tagArr.indexOf(id2) > -1) {
          this.tagArr.splice(this.tagArr.indexOf(id2), 1);
          let flag = false;
          parent.subTags.some((item, index) => {
            if (this.tagArr.indexOf(String(item.LabelId)) > -1) {
              flag = true;
              return true;
            }
          });
          if (!flag) {
            this.tagArr.splice(this.tagArr.indexOf(id1), 1);
          }
        } else {
          this.tagArr.push(id2);
          if (this.tagArr.indexOf(id1) === -1) {
            this.tagArr.push(id1);
          }
        }
      },
      // 父标签状态切换
      pTagStatusSwitch(data) {
        const i = this.tagArr.indexOf(String(data.LabelId));
        if (i > -1) {
          this.tagArr.splice(i, 1);
          data.subTags.forEach((item, index) => {
            const j = this.tagArr.indexOf(String(item.LabelId));
            if (j > -1) {
              this.tagArr.splice(j, 1);
            }
          });
        } else {
          this.tagArr.push(String(data.LabelId));
          data.subTags.forEach((item, index) => {
            this.tagArr.push(String(item.LabelId));
          });
        }
      },
      // 关闭标签弹窗
      closeTagW(tag) {
        this.tagTrigger = false;
        if (tag === 1) {
          this.formData.adTag = "," + this.tagArr.join(",") + ",";
          this.filterTagNameById();
        } else {
          this.filterTagNameById();
        }
      },
      // 切换策略
      changeStrategy(index) {
        this.strategysIndex = index;
        // 同步当前策略选择广告位
        this.resetAds();
      },
      // 新增策略
      openStrategyWindow() {
        if (this.strategys.length >= 8) {
          this.$message.error("单个计划最多可以有8个策略");
          return;
        }
        // 显示新增策略弹窗
        this.strategyTrigger = true;
      },
      // 修改素材
      confirmMaterial(materials) {
        this.materials = materials.map(item => {
          delete item.isNew;
          return item;
        });
      },
      // 生成24小时时间表
      creatHour24() {
        let hour24 = [];
        // 动态创建
        for (let i = 0; i <= 24; i++) {
          hour24.push({
            value: i,
            label: `${i}时`
          });
        }
        return hour24;
      },
      // 默认选中时间段
      defaultTimeStage() {
        let timesStage = [];
        // 循环一周
        for (let i = 1; i < 8; i++) {
          timesStage.push({
            Day: i,
            BeginHour: 0,
            EndHour: 24,
            LimitType: -1,
            LimitQty: ""
          });
        }
        return timesStage;
      },
      // 按天筛选
      filterWeek(week, day) {
        // 同步天
        this.curWeekDay = week;
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];
        this.$set(strategyActive, "curWeekDay", week);
        // 关闭日期筛选弹窗
        this.weekStatus = false;

        function verifIsHide(item, day) {
          for (let j = 0; j < item.length; j++) {
            let hourLimit = item[j];
            if (hourLimit.Day === day) {
              return true;
            }
          }
          return false;
        }

        for (let i = 0; i < strategyActive.HourLimits.length; i++) {
          let item = strategyActive.HourLimits[i];
          let firstHour = item[0].isShow;
          if (day === 0) {
            let isHide =
              typeof firstHour === "boolean" && firstHour ? firstHour : false;
            item[0].isShow = true;
          } else {
            if (verifIsHide(item, day)) {
              item[0].isShow = true;
            } else {
              item[0].isShow = false;
            }
          }
        }
      },
      // 当前限流显示状态
      hourLimitIsShow(item) {
        let isShow = item[0].isShow;
        if (typeof isShow === "boolean") {
          if (isShow) {
            return true;
          }
          return false;
        }
        return true;
      },
      // 选择天
      selectDay(item) {
        let days = [
          {
            name: "周一",
            selected: false
          },
          {
            name: "周二",
            selected: false
          },
          {
            name: "周三",
            selected: false
          },
          {
            name: "周四",
            selected: false
          },
          {
            name: "周五",
            selected: false
          },
          {
            name: "周六",
            selected: false
          },
          {
            name: "周日",
            selected: false
          }
        ];
        for (let i = 0; i < item.length; i++) {
          days[item[i].Day - 1].selected = true;
        }
        return days;
      },
      // 修改时间同步
      timeSelect(days) {
        for (let i = 1; i < days.length; i++) {
          for (let key in days[0]) {
            if (key !== "Day") {
              days[i][key] = days[0][key];
            }
          }
        }
      },
      // 添加限流数据
      addHourLimit(data, index) {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];
        // 对比时间段有没有冲突
        if (this.checkLimitTime()) {
          return;
        }
        strategyActive.HourLimits.push(this.defaultTimeStage());
      },
      // 集合取交集
      intersect(arr, fn) {
        let result = [];
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < arr[i].length; j++) {
            let str = arr[i][j];
            if (!obj[str]) {
              obj[str] = 1;
            } else {
              result.push(str);
            }
          }
        }
        return result;
      },
      // 检测限流时间
      checkLimitTime(index, hourLimitList) {
        // 当前策略下标
        // 当前策略
        let strategys = this.strategys;

        // console.log(strategyActive.HourLimits)
        for (let l = 0; l < strategys.length; l++) {
          let days = {};

          // 找每天的所有时间段
          for (
            let i = 0, hourLimitList = strategys[l].HourLimits;
            i < hourLimitList.length;
            i++
          ) {
            for (let j = 0; j < hourLimitList[i].length; j++) {
              let timeSlot = hourLimitList[i][j];
              // 如果没有空间 创建一个空间
              days[timeSlot.Day] || (days[timeSlot.Day] = []);
              // 时间区间
              let times = [];
              // 填充开始时间到小于结束时间的时间点
              for (let k = timeSlot.BeginHour; k < timeSlot.EndHour; k++) {
                times.push(k);
              }
              days[timeSlot.Day].push(times);
            }
          }
          // 对比每天所有时间段有没有交叉
          for (let key in days) {
            let repeatTime = this.intersect(days[key]);
            if (repeatTime.length) {
              let errorMessge = `<${strategys[l].AdTaskName}>周${key}时间段重复`;
              this.$message.error(errorMessge);
              return errorMessge;
            }
          }
        }
      },
      // 删除限流数据
      removeHourLimit(data, index) {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        if (strategyActive.HourLimits.length > 1) {
          strategyActive.HourLimits.splice(index, 1);
        } else {
          this.$message({
            message: "抱歉，最后一条限流数据不能删除",
            type: "warning"
          });
        }
      },
      // 找重复天
      findRepeatDay(data, day) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].Day === day + 1) {
            return {index: i};
          }
        }
      },
      // 限流日状态切换
      weekStatusSwitch(ev, data, index) {
        // 切换当前选中状态 添加删除天数据
        let currentDay = this.findRepeatDay(data, index);
        if (currentDay) {
          if (data.length > 1) {
            this.$delete(data, currentDay.index);
          } else {
            this.$message({
              message: `单条限流选择不能小于一天～`,
              type: "warning"
            });
          }
        } else {
          data.push(Object.assign({}, data[0], {Day: index + 1}));
        }
        // 对比时间段有没有冲突
        this.checkLimitTime();
      },
      // 打开新增策略弹窗
      openStrategyW() {
        this.addStrtegy = {
          strategyType: 1,
          strategyItem: this.strategyList[0].id,
          strategyName: ""
        };
      },
      appendStrategy() {
        // 新增策略信息
        let addStrtegy = this.addStrtegy;
        // 策略列表
        let strategys = this.strategys;

        // 新策略名称不可为空
        if (addStrtegy.strategyName.trim() === "") {
          this.$message.error("新策略名称不可为空");
          return;
        }
        // 策略名称不能重复
        for (let i = 0, strategys = this.strategys; i < strategys.length; i++) {
          let item = strategys[i];
          if (item.AdTaskName.trim() === addStrtegy.strategyName.trim()) {
            this.$message.error("策略名称已经存在，请重新编辑");
            return;
          }
        }
        // 新增策略
        if (addStrtegy.strategyType == 1) {
          strategys.push(this.newStrategy(addStrtegy.strategyName, true));
        } else {
          // 复制策略索引
          let strategyItem = addStrtegy.strategyItem;
          if (typeof strategyItem === "undefined") {
            this.$message.error("请选择复制哪个策略？");
            return;
          }
          // 复制策略信息
          let data = Object.assign({}, strategys[strategyItem]);
          // 设置复制新策略名称
          data.AdTaskName = addStrtegy.strategyName;
          // 重制策略开启状态
          data.IsComplete = true;
          // 新增策略putonid为零
          data.PutOnId = 0;
          // 按天筛选为默认"全部"
          data.curWeekDay = "全部";
          // 按全部筛选
          for (
            let i = 0, hourLimits = data.HourLimits;
            i < hourLimits.length;
            i++
          ) {
            let item = hourLimits[i][0];
            item.isShow = true;
          }
          // 清空选中广告位
          data.SourceLimits = [];
          data.ShieldSourceId = [];
          // 清空广告位小时限流
          data.allAdsLimit = [];
          data.sourceAdsLimit = [];
          data.shieldAdsLimit = [];

          strategys.push(data);
        }
        // 关闭新增策略弹窗
        this.strategyTrigger = false;
        // 切换至最新添加策略
        this.changeStrategy(strategys.length - 1);
      },
      // 获取城市列表
      getAreaList() {
        getAreaList().then(res => {
          let data = JSON.parse(JSON.stringify(res));
          let areaList = [];

          data.forEach((item, index) => {
            if (item.AreaLevel === 2) {
              item.subProvinces = [];
              areaList.push(item);
            }
          });
          data.forEach((item, index) => {
            areaList.forEach((aItem, aIndex) => {
              if (item.ParentAreaCode === aItem.Areacode) {
                item.subCities = [];
                aItem.subProvinces.unshift(item);
              }
            });
          });
          data.forEach((item, index) => {
            areaList.forEach((aItem, aIndex) => {
              aItem.subProvinces.forEach((pItem, pIndex) => {
                if (
                  item.ParentAreaCode === pItem.Areacode &&
                  pItem.Areacode != 0
                ) {
                  pItem.subCities.unshift(item);
                }
              });
            });
          });
          this.areaList = areaList;
        });
      },
      // 隐藏子城市列表
      hideSubCities() {
        this.activeAreaCode = -1;
      },
      // 打开地域弹窗
      openAreaW() {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        const putonIds = strategyActive.PutOnAreaId;
        this.areaList.forEach((aItem, aIndex) => {
          aItem.subProvinces.forEach((pItem, pIndex) => {
            pItem.subCities.forEach((cItem, cIndex) => {
              if (putonIds.indexOf(cItem.Areacode) > -1) {
                cItem.selected = true;
                pItem.selected = true;
                aItem.selected = true;
              }
            });
          });
        });
        // 这个操作是为了地域弹窗数据重排
        this.areaList = JSON.parse(JSON.stringify(this.areaList));
      },
      // 显示子城市列表
      showSubCities(data) {
        if (data.subCities.length > 0) {
          this.activeAreaCode = data.Areacode;
        }
      },
      // 点击省选项
      clickProvinceItem(area, province) {
        if (province.selected) {
          province.selected = false;
          province.subCities.forEach((item, index) => {
            item.selected = false;
          });
          let tag = false;
          area.subProvinces.forEach((item, index) => {
            if (item.selected) {
              tag = true;
            }
          });
          area.selected = tag;
        } else {
          province.selected = true;
          area.selected = true;
          province.subCities.forEach((item, index) => {
            item.selected = true;
          });
        }
        this.areaList = JSON.parse(JSON.stringify(this.areaList));
      },
      // 点击地区选项
      clickAreaItem(area) {
        if (area.selected) {
          area.selected = false;
          area.subProvinces.forEach((pItem, pIndex) => {
            pItem.selected = false;
            pItem.subCities.forEach((cItem, cIndex) => {
              cItem.selected = false;
            });
          });
        } else {
          area.selected = true;
          area.subProvinces.forEach((pItem, pIndex) => {
            pItem.selected = true;
            pItem.subCities.forEach((cItem, cIndex) => {
              cItem.selected = true;
            });
          });
        }
        this.areaList = JSON.parse(JSON.stringify(this.areaList));
      },
      // 点击城市选项
      clickCityItem(area, province, city) {
        if (city.selected) {
          city.selected = false;
          let ptag = false;
          let atag = false;
          province.subCities.forEach((item, index) => {
            if (item.selected) {
              ptag = true;
            }
          });
          province.selected = ptag;
          area.subProvinces.forEach((item, index) => {
            if (item.selected) {
              atag = true;
            }
          });
          area.selected = atag;
        } else {
          city.selected = true;
          province.selected = true;
          area.selected = true;
        }
        this.areaList = JSON.parse(JSON.stringify(this.areaList));
      },
      // 关闭地域弹窗
      closeAreaW(tag) {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        this.areaTrigger = false;
        if (tag === 1) {
          let currentStrategyArr = [];
          this.areaList.forEach((aItem, aIndex) => {
            aItem.selected = false;
            aItem.subProvinces.forEach((pItem, pIndex) => {
              pItem.selected = false;
              pItem.subCities.forEach((cItem, cIndex) => {
                if (cItem.selected) {
                  currentStrategyArr.push(cItem.Areacode);
                }
                cItem.selected = false;
              });
            });
          });
          strategyActive.PutOnAreaId = "," + currentStrategyArr.join(",") + ",";
          strategyActive.PutOnAreaId = strategyActive.PutOnAreaId;
        } else {
          this.areaList.forEach((aItem, aIndex) => {
            aItem.selected = false;
            aItem.subProvinces.forEach((pItem, pIndex) => {
              pItem.selected = false;
              pItem.subCities.forEach((cItem, cIndex) => {
                cItem.selected = false;
              });
            });
          });
        }
      },
      // 同步当前策略广告位信息
      resetAds() {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        let res = this.allAdsList;

        // 设置初始定投广告位
        let pList = [];
        // 设置初始屏蔽广告位
        let sList = [];

        for (let i = 0; i < res.length; i++) {
          let item = res[i];

          if (strategyActive.PutOnSourceId.indexOf(item.SourceId) > -1) {
            pList.push({
              id: item.SourceId,
              name: item.SourceName
            });
          }

          if (strategyActive.ShieldSourceId.indexOf(item.SourceId) > -1) {
            sList.push({
              id: item.SourceId,
              name: item.SourceName
            });
          }
        }

        let oPList = {};
        pList.map(item => {
          oPList[item.id] = item;
        });

        this.pList = Object.values(oPList);
        this.sList = sList;

        // 删除不在投放状态的广告限流
        // let takeEffect = this.contrastAdsTakeEffect(strategyActive)
        //
        // if (takeEffect.length) {
        //   this.$notify({
        //     title: '提示',
        //     message: `${takeEffect.join('，')} 广告位不在投放状态，系统自动帮您取消对该广告位设置的所有小时限流！`,
        //     type: 'warning'
        //   })
        // }
      },
      // 获取广告位列表
      getAllActivities() {
        let data = {
          IsMiniApp: 1
        };
        getMediaList(data).then(res => {
          // 原数据（对比）
          this.allAdsList = res.map(item => item);
          // 真正操作的数据
          this.copyAdsList = res.map(item => {
            item.isSelected = false;
            return item;
          });

          // 初始化广告位列表
          this.resetAds();
        });
      },
      // 打开广告位弹窗
      openAdsW(tag) {
        // 清空搜索关键词
        this.mediaKeyWord = "";
        // 同步不是小时限流打开的广告位弹窗
        this.limitTimeStatus = false;
        // 显示广告位列表弹窗
        this.adsWS = true;
        // 当前是定投还是屏蔽 true = 定投
        this.isPutOn = tag === 0 ? true : false;
        // 选中当前策略广告位
        this.switchCurrentAds();
      },
      // 选中当前策略广告位
      switchCurrentAds() {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        // 清空所有选中广告位
        this.copyAdsList.map(item => {
          item.isHide = false;
          item.isSelected = false;
        });

        let adList = [];
        // 定投广告位
        if (this.isPutOn) {
          adList = strategyActive.PutOnSourceId;
        } else {
          adList = strategyActive.ShieldSourceId;
        }
        // 选中当前策略对应类型广告位
        for (
          let i = 0, copyAdsList = this.copyAdsList;
          i < copyAdsList.length;
          i++
        ) {
          let item = copyAdsList[i];
          if (adList.indexOf(item.SourceId) > -1) {
            item.isSelected = true;
          }
        }
      },
      // 当前广告为是否显示
      adIsShow(item) {
        if (typeof item.isShow === "undefined") {
          return true;
        } else {
          if (item.isShow) {
            return true;
          } else {
            return false;
          }
        }
      },
      // 按照id或按照名称筛选广告位
      filterAds(key, tag) {
        let adList = [];
        // 定投
        if (tag === 0) {
          adList = this.pList;
        } else {
          adList = this.sList;
        }
        for (let i = 0; i < adList.length; i++) {
          let item = adList[i];
          if (key === "") {
            this.$set(item, "isShow", true);
          } else {
            if (
              String(item.id).indexOf(key) > -1 ||
              item.name.toLowerCase().indexOf(key.toLowerCase()) > -1
            ) {
              this.$set(item, "isShow", true);
            } else {
              this.$set(item, "isShow", false);
            }
          }
        }
      },
      // 删除广告位
      deleteAds(id, tag) {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];
        // 定投
        if (tag === 0) {
          let PutOnSourceId = strategyActive.PutOnSourceId;
          PutOnSourceId.splice(PutOnSourceId.indexOf(id), 1);
        } else {
          let ShieldSourceId = strategyActive.ShieldSourceId;
          ShieldSourceId.splice(ShieldSourceId.indexOf(id), 1);
        }

        // 同步删除之后的列表
        this.resetAds();
      },
      // 筛选广告位列表
      searchMedia() {
        // 搜索关键词
        let mediaKeyWord = this.mediaKeyWord.trim();
        let copyAdsList = this.copyAdsList;

        if (this.limitTimeStatus) {
          // 当前策略下标
          const ind = this.strategysIndex;
          // 当前策略
          let strategyActive = this.strategys[ind];

          // 获取当前策略广告位投放类型下广告位ID
          let {takeEffect, currentAds} = this.currentAdsList(strategyActive);

          for (let i = 0; i < currentAds.length; i++) {
            let item = currentAds[i];
            if (
              String(item.SourceId).indexOf(mediaKeyWord) > -1 ||
              item.SourceName.indexOf(mediaKeyWord) > -1
            ) {
              item.isHide = false;
            } else {
              item.isHide = true;
            }
          }
        } else {
          for (
            let i = 0, copyAdsList = this.copyAdsList;
            i < copyAdsList.length;
            i++
          ) {
            let item = copyAdsList[i];
            if (
              String(item.SourceId).indexOf(mediaKeyWord) > -1 ||
              item.SourceName.indexOf(mediaKeyWord) > -1
            ) {
              item.isHide = false;
            } else {
              item.isHide = true;
            }
          }
        }
      },
      // 切换广告位状态
      switchAdsStatus(ads, i) {
        // 强制监听
        this.$set(
          this.copyAdsList,
          i,
          Object.assign({}, ads, {isSelected: !ads.isSelected})
        );
      },
      // 关闭广告位弹窗
      closeAdsW(tag) {
        // 弹窗确定
        if (tag) {
          // 当前策略下标
          const ind = this.strategysIndex;
          // 当前策略
          let strategyActive = this.strategys[ind];
          let copyAdsList = this.copyAdsList;

          if (this.limitTimeStatus) {
            let selectedAdsLimit = [];
            for (let i = 0; i < copyAdsList.length; i++) {
              let item = copyAdsList[i];
              if (item.isSelected) {
                selectedAdsLimit.push(item);
              }
            }
            this.selectedAdsLimit = selectedAdsLimit;
            if (selectedAdsLimit.length) {
              if (selectedAdsLimit.length > 30) {
                this.errorMessge(
                  `单次广告位选择不可超过30个，当前共${selectedAdsLimit.length}个`
                );
              } else {
                this.limitTrigger = true;
              }
            } else {
              this.errorMessge("最少选择一条广告位");
            }
            return;
          } else {
            // 定投
            let checkedAds = [];
            for (let i = 0; i < copyAdsList.length; i++) {
              let item = copyAdsList[i];
              if (item.isSelected) {
                if (this.isPutOn) {
                  let LimitAmount = "0";
                  for (
                    let j = 0, SourceLimits = strategyActive.SourceLimits;
                    j < SourceLimits.length;
                    j++
                  ) {
                    if (item.SourceId === SourceLimits[j].SourceId) {
                      // 如果有预算 同步预算
                      LimitAmount = SourceLimits[j].LimitAmount || "0";
                    }
                  }
                  item.LimitAmount = LimitAmount;
                }
                checkedAds.push(item);
              }
            }
            if (this.isPutOn) {
              strategyActive.PutOnSourceId = checkedAds.map(
                item => item.SourceId
              );
            } else {
              strategyActive.ShieldSourceId = checkedAds.map(
                item => item.SourceId
              );
            }
          }
        }
        // 选中当前策略下广告位
        this.resetAds();
        // 关闭选择广告位弹窗
        this.adsWS = false;
        // 清空搜索条件
        this.mediaKeyWord = "";
        // 清空搜索条件后重制广告位
        this.searchMedia();
      },
      // 取excel数据
      readFile(file, fn) {
        var name = file.name;
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;
          var wb = XLSX.read(data, {type: "binary"});
          var data = wb.Sheets[wb.SheetNames[0]];
          var dataList = {};

          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              // 首字符
              var k1 = key.substring(0, 1);
              // 索引
              var k2 = key.substring(1);

              if (Number(k2) > 0) {
                if (!dataList[k2]) {
                  dataList[k2] = {};
                }

                if (k1 === "A") {
                  dataList[k2].SourceId = data[key].v;
                } else if (k1 === "B") {
                  dataList[k2].SourceName = data[key].v;
                }
              }
            }
          }

          let arr = Object.values(dataList);
          arr.shift();

          fn && fn(arr);
        };
        reader.readAsBinaryString(file);
      },
      // 找重复广告位
      findArr(arr, arr2) {
        let suc = [];
        let err = [];
        let notFind = [];

        let data = {};
        // 创建字典
        for (let i = 0; i < arr2.length; i++) {
          data[arr2[i].SourceId] = arr2[i];
        }
        // 查字典
        for (let i = 0; i < arr.length; i++) {
          let sourceId = arr[i].SourceId;
          if (data[sourceId]) {
            if (data[sourceId].SourceName === arr[i].SourceName) {
              suc.push(arr[i]);
            } else {
              err.push(arr[i]);
            }
          } else {
            notFind.push(arr[i]);
          }
        }
        return {
          suc,
          err,
          notFind
        };
      },
      // 导入定投广告位
      importAd(ev, tag) {
        let files = ev.target.files;
        var f = files[0];
        // 当前是定投还是屏蔽 true = 定投
        this.isPutOn = tag === 0 ? true : false;

        this.readFile(f, data => {
          let arr = [];
          let adList = this.allAdsList;
          let dataLen = data.length;
          if (dataLen > 200) {
            data = null;
            this.errorMessge("导入的广告位超过200个，请调整后再试!");
            return;
          }
          // 重复广告
          let repeatAds = {};
          // 按广告ID排重
          let findInfniteAd = {};
          for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let sourceId = item.SourceId;
            if (findInfniteAd[sourceId]) {
              if (repeatAds[sourceId]) {
                repeatAds[sourceId].num++;
              } else {
                repeatAds[sourceId] = {
                  SourceId: sourceId,
                  num: 1
                };
              }
            } else {
              findInfniteAd[sourceId] = item;
            }
          }
          data = Object.values(findInfniteAd);

          let {suc} = this.findArr(data, adList);
          for (let i = 0; i < suc.length; i++) {
            let obj = {
              id: suc[i].SourceId,
              name: suc[i].SourceName,
              money: 0
            };
            arr.push(obj);
          }

          // 当前策略下标
          const ind = this.strategysIndex;
          // 当前策略
          let strategyActive = this.strategys[ind];

          let pList = [];
          // 定投
          if (this.isPutOn) {
            pList = strategyActive.SourceLimits.map(item => {
              return item.SourceId;
            });
          } else {
            pList = strategyActive.ShieldSourceId;
          }

          // 广告位去重
          let arr2 = [];
          for (let i = 0; i < arr.length; i++) {
            if (pList.indexOf(arr[i].id) === -1) {
              arr2.push(arr[i]);
            }
          }

          // 定投
          if (this.isPutOn) {
            let sourceLimits = arr2.map(item => {
              return {
                SourceId: item.id,
                LimitAmount: item.money
              };
            });
            strategyActive.SourceLimits = strategyActive.SourceLimits.concat(
              sourceLimits
            );
            this.$notify({
              title: "成功",
              message: `导入${dataLen}条，成功导入${sourceLimits.length}条`,
              type: "success"
            });
          } else {
            strategyActive.ShieldSourceId = strategyActive.ShieldSourceId.concat(
              arr2.map(item => item.id)
            );
            this.$notify({
              title: "成功",
              message: `导入${dataLen}条，成功导入${arr2.length}条`,
              type: "success"
            });
          }
          this.resetAds();
        });
        ev.target.value = "";
      },
      // 设置预算
      configBudget(ad) {
        // 显示设置预算弹窗
        this.budgetTrigger = true;
        // 同步当前选中广告位预算
        this.budgetConfig = Object.assign({}, ad);
      },
      // 确定设置预算
      setBudget() {
        let budgetConfig = this.budgetConfig;
        if (budgetConfig.money.trim() === "") {
          this.$message.error("广告位预算不能为空～");
          return;
        }
        if (
          !(Number(budgetConfig.money) >= 0) ||
          verifFloat(String(budgetConfig.money))
        ) {
          this.$message.error("请输入大于等于零的整数~");
          return;
        }
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        // 同步当前策略预算
        for (
          let i = 0, SourceLimits = strategyActive.SourceLimits;
          i < SourceLimits.length;
          i++
        ) {
          if (budgetConfig.id === SourceLimits[i].SourceId) {
            SourceLimits[i].LimitAmount = Number(budgetConfig.money);
          }
        }
        // 同步当前广告预算
        this.pList = this.pList.map(item => {
          if (item.id === budgetConfig.id) {
            item.money = Number(budgetConfig.money);
          }
          return item;
        });

        // 关闭编辑预算
        this.budgetTrigger = false;
      },
      // 获取富文本内容
      getUEContent() {
        return this.$refs.ue.getUEContent(); // 调用子组件方法
      },
      // 抛出错误信息
      errorMessge(msg) {
        this.$message.error(msg);
      },
      // 新广告位限流
      newAdLimitHour() {
        return {
          BeginHour: 0,
          EndHour: 24,
          LimitType: -1,
          LimitQty: 0
        };
      },
      // 当前状态下的广告位id
      currentAdsIdList(strategy) {
        let takeEffect = [];
        let sourceRange = strategy.SourceRange;
        if (sourceRange === 0) {
          takeEffect = this.allAdsList.map(item => {
            return item.SourceId;
          });
        } else if (sourceRange === 1) {
          takeEffect = strategy.PutOnSourceId;
        } else if (sourceRange === 2) {
          let shieldSourceId = strategy.ShieldSourceId;

          for (
            let i = 0, allAdsList = this.allAdsList;
            i < allAdsList.length;
            i++
          ) {
            let item = allAdsList[i];
            let sourceId = item.SourceId;
            if (shieldSourceId.indexOf(sourceId) === -1) {
              takeEffect.push(sourceId);
            }
          }
        }
        return takeEffect;
      },
      // 获取当前状态下广告位
      currentAdsList(strategy) {
        // 当前状态下广告位ID
        let takeEffect = this.currentAdsIdList(strategy);
        // 当前状态可用的广告位
        let currentAds = [];
        // 当前广告位投放类型
        let sourceRange = strategy.SourceRange;
        let copyAdsList = this.copyAdsList;

        if (sourceRange === 0) {
          currentAds = copyAdsList;
        } else if (sourceRange === 1 || sourceRange === 2) {
          copyAdsList.map(item => {
            let sourceId = item.SourceId;
            if (takeEffect.indexOf(sourceId) > -1) {
              currentAds.push(item);
            }
          });
        }
        return {
          takeEffect,
          currentAds
        };
      },
      // 删除没有在投放状态的广告位的小时限流
      contrastAdsTakeEffect(strategy, isRemove = true) {
        let takeEffect = this.currentAdsList(strategy);
        let {data, key} = this.getCurrentAdsLimit();
        let wrongLimits = [];
        let resultLimit = [];

        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (takeEffect.indexOf(item.SourceId) === -1) {
            wrongLimits.push(item.SourceId);
          } else {
            resultLimit.push(item);
          }
        }

        if (isRemove) {
          strategy[key] = resultLimit;
        }
        return delRepeat(wrongLimits);
      },
      // 编辑限流设置
      editLimit() {
        // 清空搜索关键词
        this.mediaKeyWord = "";
        // 同步为小时限流打开的广告位弹窗
        this.limitTimeStatus = true;
        // 添加一条默认的
        this.adSLimitHour = [this.newAdLimitHour()];
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];
        let sourceRange = strategyActive.SourceRange;
        let copyAdsList = this.copyAdsList;
        // 清空所有选中广告位
        copyAdsList.map(item => {
          item.isSelected = false;
          item.isHide = false;
        });

        // 获取当前策略广告位投放类型下广告位ID
        let {takeEffect, currentAds} = this.currentAdsList(strategyActive);

        if (sourceRange === 1) {
          // 定投
          let putOnSourceId = strategyActive.PutOnSourceId;

          for (let i = 0; i < copyAdsList.length; i++) {
            let item = copyAdsList[i];
            let sourceId = item.SourceId;
            if (putOnSourceId.indexOf(sourceId) === -1) {
              this.$set(item, "isHide", true);
            } else {
              this.$set(item, "isHide", false);
            }
          }
        } else if (sourceRange === 2) {
          // 屏蔽
          let shieldSourceId = strategyActive.ShieldSourceId;

          for (let i = 0; i < copyAdsList.length; i++) {
            let item = copyAdsList[i];
            let sourceId = item.SourceId;
            if (shieldSourceId.indexOf(sourceId) > -1) {
              this.$set(item, "isHide", true);
            } else {
              this.$set(item, "isHide", false);
            }
          }
        }

        // 显示广告位列表弹窗
        this.adsWS = true;
      },
      // 获取当前广告位限流
      getCurrentAdsLimit(strategyActive) {
        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        strategyActive = strategyActive || this.strategys[ind];
        // 当前选中广告位设置
        let sourceRange = strategyActive.SourceRange;

        let key = "";
        // 所有
        if (sourceRange === 0) {
          key = "allAdsLimit";
        } else if (sourceRange === 1) {
          key = "sourceAdsLimit";
        } else if (sourceRange === 2) {
          key = "shieldAdsLimit";
        }
        return {
          key: "allAdsLimit",
          data: strategyActive.SourceLimits
        };
      },
      // 对比设置限流设置广告位
      contrastAdLimitHour(limitTime) {
        if (limitTime) {
          // 按广告位id分组
          let adLimit = {};
          for (let i = 0; i < limitTime.length; i++) {
            let item = limitTime[i];
            adLimit[item.SourceId] || (adLimit[item.SourceId] = []);
            let arr = [];
            for (let k = item.BeginHour; k < item.EndHour; k++) {
              arr.push(k);
            }
            adLimit[item.SourceId].push(arr);
          }

          // 对比每天所有时间段有没有交叉
          for (let key in adLimit) {
            let repeatTime = this.intersect(adLimit[key]);
            if (repeatTime.length) {
              let errorMessge = `ID为：${key}的广告位时间段重复，重复时间段为:${
                repeatTime[0]
                }-${repeatTime[repeatTime.length - 1] + 1}`;
              this.$message.error(errorMessge);
              return errorMessge;
            }
          }
        } else {
          // 当前策略
          let strategys = this.strategys;

          for (let i = 0; i < strategys.length; i++) {
            let item = strategys[i];
            let adLimit = {};
            for (let j = 0; j < item.SourceLimits.length; j++) {
              let sItem = item.SourceLimits[j];
              adLimit[sItem.SourceId] || (adLimit[sItem.SourceId] = []);
              let arr = [];
              for (let k = sItem.BeginHour; k < sItem.EndHour; k++) {
                arr.push(k);
              }
              adLimit[sItem.SourceId].push(arr);
            }
            // 对比每天所有时间段有没有交叉
            for (let key in adLimit) {
              let repeatTime = this.intersect(adLimit[key]);
              if (repeatTime.length) {
                let errorMessge = `策略：<${
                  item.AdTaskName
                  }> ID为：${key}的广告位时间段重复`;
                this.$message.error(errorMessge);
                return errorMessge;
              }
            }
          }
        }
      },
      // 添加广告位限流（弹窗内）
      addAdLimitHour() {
        // 当前广告位限流设置
        let {data, key} = this.getCurrentAdsLimit();
        // 给当前选中广告位同步小时限流
        let newChecked = [];
        for (
          let l = 0, selectedAdsLimit = this.selectedAdsLimit;
          l < selectedAdsLimit.length;
          l++
        ) {
          for (
            let i = 0, adSLimitHour = this.adSLimitHour;
            i < adSLimitHour.length;
            i++
          ) {
            let hItem = JSON.parse(JSON.stringify(adSLimitHour[i]));
            let sItem = JSON.parse(JSON.stringify(selectedAdsLimit[l]));
            hItem.SourceId = sItem.SourceId;
            hItem.SourceName = sItem.SourceName;
            newChecked.push(hItem);
          }
        }
        let limitTime = JSON.parse(JSON.stringify(newChecked.concat(data || [])));

        // 当前策略下标
        const ind = this.strategysIndex;
        // 当前策略
        let strategyActive = this.strategys[ind];

        if (!this.contrastAdLimitHour(limitTime)) {
          if (this.adSLimitHour.length === 3) {
            this.errorMessge("单次限流时间段不可超过3个");
          } else {
            this.adSLimitHour.push(this.newAdLimitHour());
          }
        }
      },
      // 删除广告位限流（弹窗内）
      removeAdLimitHourPop(index) {
        this.adSLimitHour.splice(index, 1);
      },
      // 删除广告位限流
      removeAdLimitHour(index) {
        let {data} = this.getCurrentAdsLimit();
        data.splice(index, 1);
      },
      // 关闭广告位限流弹窗
      closeLimitW(tag) {
        if (tag) {
          // 当前广告位限流设置
          let {data, key} = this.getCurrentAdsLimit();
          // 给当前选中广告位同步小时限流
          let newChecked = [];
          for (
            let l = 0, selectedAdsLimit = this.selectedAdsLimit;
            l < selectedAdsLimit.length;
            l++
          ) {
            for (
              let i = 0, adSLimitHour = this.adSLimitHour;
              i < adSLimitHour.length;
              i++
            ) {
              let hItem = JSON.parse(JSON.stringify(adSLimitHour[i]));
              let sItem = JSON.parse(JSON.stringify(selectedAdsLimit[l]));
              hItem.SourceId = sItem.SourceId;
              hItem.SourceName = sItem.SourceName;
              newChecked.push(hItem);
            }
          }
          let limitTime = JSON.parse(
            JSON.stringify(newChecked.concat(data || []))
          );

          // 当前策略下标
          const ind = this.strategysIndex;
          let strategys = JSON.parse(JSON.stringify(this.strategys));
          // 当前策略
          let strategyActive = strategys[ind];
          if (this.contrastAdLimitHour(limitTime)) {
            return;
          } else {
            for (let i = 0; i < newChecked.length; i++) {
              let item = newChecked[i];
              if (item.LimitType === -1) {
                this.errorMessge(`限流类型：请选择第${i + 1}条限流设置限流类型`);
                return;
              }
              if (item.LimitQty !== "") {
                let limitQty = Number(item.LimitQty);
                if (
                  isNaN(limitQty) ||
                  limitQty < 0 ||
                  verifFloat(String(limitQty))
                ) {
                  this.errorMessge(
                    `数值：第${i +
                    1}条限流设置限流数值填写有误，输入值必须为>=0的整数`
                  );
                  return;
                }
              }
            }

            strategyActive.SourceLimits = limitTime;
            this.$set(this, "strategys", strategys);
          }
          // 关闭广告位弹窗
          this.adsWS = false;
          this.selectedAdsLimit = [];
        } else {
        }

        // 关闭广告位列表弹窗
        this.limitTrigger = false;
      },
      // 切换广告位小时限流（外部）
      adLimitChange() {
        this.contrastAdLimitHour();
      },
      // 验证提交参数
      badParams(data) {
        // 广告ID
        if (!data.AdId) {
          this.errorMessge("请选择：广告ID/名称");
          return true;
        }
        // 计划名称
        if (!data.AdTaskName) {
          this.errorMessge("请输入：计划名称");
          return true;
        }
        // 投放链接
        let AdrLink = data.AdrLink.trim();
        if (!AdrLink) {
          this.errorMessge("请输入：投放链接");
          return true;
        }
        // else if (!/^((ht|f)tps?):\/\//i.test(AdrLink)) {
        //   this.errorMessge("投放链接必须以http/https/ftp/ftps开头");
        //   return true;
        // } else if (!verifLink(AdrLink)) {
        //   this.errorMessge("投放链接格式不正确");
        //   return true;
        // }
        // 小程序ID
        let MiniAppId = data.MiniAppId.trim();
        if (!MiniAppId) {
          this.errorMessge("请输入：小程序ID");
          return true;
        }
        // 投放形式
        if (!data.PutOnTypeId) {
          this.errorMessge("请选择：投放形式");
          return true;
        }
        // 广告标签
        if (!data.LabelIds || data.LabelIds === ",,") {
          this.errorMessge("请选择：广告标签");
          return true;
        }
        // 曝光排序
        if (data.OrderType === 1) {
          if (
            (!data.OrderNum && data.OrderNum !== 0) ||
            !(data.OrderNum >= 0) ||
            verifFloat(String(data.OrderNum))
          ) {
            this.errorMessge("曝光排序必须为大于等于0的整数");
            return true;
          }
        }
        // 计划日预算
        if (
          (data.LimitAmount !== "" && !(data.LimitAmount > 0)) ||
          verifFloat(String(data.LimitAmount))
        ) {
          this.errorMessge("计划日预算必须为大于零的整数");
          return true;
        }
        // 投放日期
        if (!data.ValidityDateStart || !data.ValidityDateEnd) {
          this.errorMessge("请选择：投放日期");
          return true;
        }
        // 计费类型
        if (!data.ChargeType) {
          this.errorMessge("请选择：计费类型");
          return true;
        }
        // 投放日期
        if (!data.ValidityTimeStart || !data.ValidityTimeEnd) {
          this.errorMessge("请选择：投放时间");
          return true;
        }
        // 检查素材状态时候满足要求
        if (data.Materials.length === 0) {
          this.errorMessge("尚未添加素材");
          return true;
        }
        let {openMaterials} = this.$refs.materials.getOpenMaterial();
        if (!openMaterials.length) {
          this.errorMessge("素材至少开启一张");
          return true;
        }
        // 对比时间段有没有冲突
        let checkLimitTime = this.checkLimitTime();
        if (checkLimitTime) {
          this.$message.error(checkLimitTime);
          return true;
        }

        // 定投广告位
        let putOnAdList = {};
        // 所有策略
        let strategys = data.Strategys;
        for (let i = 0; i < strategys.length; i++) {
          let item = strategys[i];
          // 输入值必须为≥0的整数、此值为选填项
          for (let j = 0; j < item.HourLimits.length; j++) {
            let LimitQty = item.HourLimits[j][0].LimitQty;
            let limitQty = null;
            if (typeof LimitQty === "string") {
              limitQty = LimitQty.trim();
            } else {
              limitQty = LimitQty;
            }
            if (limitQty !== "") {
              /^\d+$/g.test(limitQty) &&
              !Number(limitQty) &&
              (item.HourLimits[j][0].LimitQty = limitQty);
              if (
                limitQty !== "" &&
                (!(limitQty >= 0) || verifFloat(String(limitQty)))
              ) {
                this.errorMessge(
                  `<${item.AdTaskName}>第${j +
                  1}条小时限流数值：输入值必须为≥0的整数`
                );
                return true;
              }
            }
          }
          // 操作系统
          let operatingSystem = item.OperatingSystem;
          if (operatingSystem.length === 0) {
            this.errorMessge(`<${item.AdTaskName}>操作系统为必填项`);
            return true;
          }
          // 清空首尾空格
          item.AccessPrice =
            typeof item.AccessPrice !== "number"
              ? item.AccessPrice.trim()
              : item.AccessPrice;
          let accessPrice = item.AccessPrice;
          //检查计费单价
          if (accessPrice === "") {
            this.errorMessge(`<${item.AdTaskName}>计费单价为必填项`);
            return true;
          }
          if (!(Number(accessPrice) >= 0)) {
            this.errorMessge(`<${item.AdTaskName}>计费单价必须大于等于零的数字`);
            return true;
          }
          // 清除首尾空格
          item.LimitAmount =
            typeof item.LimitAmount !== "number"
              ? item.LimitAmount.trim()
              : item.LimitAmount;

          // 策略日预算
          let imitAmount = item.LimitAmount;
          if (
            (imitAmount !== "" && !(Number(imitAmount) > 0)) ||
            verifFloat(String(imitAmount))
          ) {
            this.errorMessge(
              `策略：<${item.AdTaskName}> 策略日预算必须大于零的整数`
            );
            return true;
          }
          // 广告位小时限流
          if (this.contrastAdLimitHour()) {
            return true;
          }
          for (let j = 0; j < item.SourceLimits.length; j++) {
            let limitQty = item.SourceLimits[j].LimitQty;
            let limitType = item.SourceLimits[j].LimitType;
            if (limitType === -1) {
              this.errorMessge(
                `策略：<${item.AdTaskName}> 广告位：${
                  item.SourceLimits[j].SourceId
                  } 限流类型为必选项`
              );
              return true;
            }
            if (limitQty !== "") {
              limitQty = Number(limitQty);
              if (
                isNaN(limitQty) ||
                limitQty < 0 ||
                verifFloat(String(limitQty))
              ) {
                this.errorMessge(
                  `策略：<${item.AdTaskName}> 广告位：${
                    item.SourceLimits[j].SourceId
                    } 数值输入值必须>=0的整数`
                );
                return true;
              }
            }
          }

          if (item.IsComplete) {
            // 对比策略广告位定投是否重复
            putOnAdList[item.AdTaskName] = [];
            let sourceRange = item.SourceRange;
            if (sourceRange === 0) {
              putOnAdList[item.AdTaskName] = this.allAdsList.map(ad => {
                return ad.SourceId;
              });
            } else if (sourceRange === 1) {
              putOnAdList[item.AdTaskName] = item.PutOnSourceId;
            } else if (sourceRange === 2) {
              let shieldSourceId = item.ShieldSourceId;
              for (
                let j = 0, allAdsList = this.allAdsList;
                j < allAdsList.length;
                j++
              ) {
                let sourceId = allAdsList[j].SourceId;
                if (shieldSourceId.indexOf(sourceId) === -1) {
                  putOnAdList[item.AdTaskName].push(sourceId);
                }
              }
            }
          }
        }
        for (let key in putOnAdList) {
          putOnAdList[key] = delRepeat(putOnAdList[key]);
        }

        let intersect = this.intersect(Object.values(putOnAdList));
        // 生效广告位冲突报警
        if (intersect.length) {
          let msg = {};

          for (let i = 0; i < intersect.length; i++) {
            for (let key in putOnAdList) {
              if (putOnAdList[key].indexOf(intersect[i]) > -1) {
                msg[key] = "";
              }
            }

            this.errorMessge(
              `已开启策略<${Object.keys(msg).join(", ")}>中投放广告位"${
                intersect[i]
                }"重复！`
            );
            return true;
          }
        }
      },
      // 确定返回
      backPrevPage() {
        location.href = "/iad_puton/planlist";
      },
      // 找广告位是否存在
      findAdIsTrue(id, sourceLimits) {
        let findArr = [];
        for (let i = 0; i < sourceLimits.length; i++) {
          let item = sourceLimits[i];
          if (item.SourceId === id) {
            findArr.push(item);
          }
        }
        return findArr;
      },
      // 搜索广告位小时限流
      filterCurrentAdLimit() {
        let limitSearch = this.limitSearch;

        let {data} = this.getCurrentAdsLimit();

        for (let i = 0; i < data.length; i++) {
          let item = data[i];
          if (limitSearch === "") {
            this.$set(item, "isShow", true);
          } else {
            if (
              String(item.SourceId).indexOf(limitSearch) > -1 ||
              item.SourceName.indexOf(limitSearch) > -1
            ) {
              this.$set(item, "isShow", true);
            } else {
              this.$set(item, "isShow", false);
            }
          }
        }
      },
      // 是否显示该广告位小时限流
      adLimitIshow(item) {
        if (item.hasOwnProperty("isShow")) {
          if (item.isShow) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },
      // 广告位设置修改
      adSetChange() {
        this.limitSearch = "";
        this.filterCurrentAdLimit();
      },
      // 警告通知
      warnNotify(info) {
        this.$notify({
          title: "警告",
          message: info,
          type: "warning"
        });
      },
      // 发送数据
      saveStrategyInfo() {
        let formData = this.formData;
        console.log(formData);
        let addChar = (arr, char) => {
          return arr.length ? `${char}${arr.join(char)}${char}` : "";
        };
        let strategys = JSON.parse(JSON.stringify(this.strategys));
        let putonDate = formData.putonDate;
        let putOnTime = this.putOnTime;
        const getPutonTime = date => {
          if (date) {
            if (typeof date === "object") {
              let h = toDou(date.getHours());
              let m = toDou(date.getMinutes());
              return `${h}:${m}`;
            }
            return date;
          }
          return "";
        };

        const data = {
          copyid: this.currentCopyId,
          AdId: formData.adid,
          PutOnId: formData.putonid,
          AdTaskName: formData.planName,
          AdrLink: formData.putonLink,
          MiniAppId: formData.MiniAppId,
          AppPlatform: formData.AppPlatform,
          PutOnTypeId: formData.putonType,
          LabelIds: formData.adTag,
          OrderType: formData.exposureSort,
          OrderNum: formData.orderNum
            ? Number(formData.orderNum)
            : formData.orderNum,
          LimitAmount: formData.planDayBudget
            ? Number(formData.planDayBudget)
            : formData.planDayBudget,
          AwardType: formData.adType,
          ValidityDateStart: putonDate ? putonDate[0] : "",
          ValidityDateEnd: putonDate ? putonDate[1] : "",
          ValidityTimeStart: getPutonTime(putOnTime[0]),
          ValidityTimeEnd: getPutonTime(putOnTime[1]),
          ChargeType: formData.accountType,
          JSFlag: formData.linkJs ? 1 : 0,
          IsComplete: formData.openS ? 0 : 1,
          GraphicText: this.getUEContent(),
          ImportantStatement: formData.ImportantStatement,
          Materials: JSON.parse(JSON.stringify(this.materials)),
          Strategys: strategys
        };
        // 检查基本信息有没有填写
        if (this.badParams(data)) return;
        // 所有广告位限流
        let allAdsLimitData = [];

        for (let i = 0, strategys = data.Strategys; i < strategys.length; i++) {
          let item = strategys[i];
          // 转换系统设置
          item.OperatingSystem = addChar(item.OperatingSystem, ",").replace(
            "其他",
            "h5"
          );
          // 转换屏蔽
          item.ShieldSourceId = `,${item.ShieldSourceId.join(",")},`;
          // 转换屏蔽定投广告位
          item.PutOnSourceId = `,${item.PutOnSourceId.join(",")},`;
          // 转换策略开始状态
          item.IsComplete = item.IsComplete ? 0 : 1;
          // 转换小时限流开启状态
          item.LimitOpenState = item.LimitOpenState ? 1 : 0;
          // 同步所有策略时间段数据
          let hourLimits = item.HourLimits;
          for (let k = 0; k < hourLimits.length; k++) {
            // 处理第一个空值
            {
              let firstHour = hourLimits[k][0];

              if (
                typeof firstHour.LimitQty === "" &&
                firstHour.LimitQty.trim() === ""
              ) {
                firstHour.LimitQty = -1;
              } else {
                let limitQty = Number(firstHour.LimitQty);
                firstHour.LimitQty = isNaN(limitQty)
                  ? firstHour.LimitQty
                  : limitQty;
              }
              delete firstHour.isShow;
            }
            // 复制第一个值
            for (let j = 0, row = hourLimits[k]; j < row.length; j++) {
              let hour = row[j];
              for (let key in hour) {
                if (key !== "Day") {
                  hour[key] = row[0][key];
                }
              }
            }
          }
          // 小时限流转字符串
          item.HourLimits = JSON.stringify(item.HourLimits);
          // 获取小时限流配置
          // if (item.SourceRange === 0) {
          //   item.SourceLimits = item.allAdsLimit
          // } else if (item.SourceRange === 1) { // 定投
          //   let sourceLimits = item.SourceLimits
          //   // 当前策略未设置限流的广告位
          //   let notSetLimit = []
          //   for (let j = 0, sourceLimits = item.SourceLimits; j < sourceLimits.length; j++) {
          //     let adItem = sourceLimits[j]
          //     if (!adItem.hasOwnProperty('BeginHour')) {
          //       notSetLimit.push(adItem)
          //     }
          //   }
          //   // 设置过限流的广告位+未设置过的
          //   let result = notSetLimit.concat(item.sourceAdsLimit)
          //   // 中途取消的广告位
          //   let cancelLimitAds = []
          //   sourceLimits.map(sAd => {
          //     let bl = true
          //     result.map(ad => {
          //       if (ad.SourceId === sAd.SourceId) {
          //         bl = false
          //       }
          //     })
          //     if (bl) {
          //       cancelLimitAds.push({SourceId: sAd.SourceId})
          //     }
          //   })
          //   // 当前策略所有广告位信息=未设置限流广告位+限流广告位+已取消小时限流广告位
          //   item.SourceLimits = result.concat(cancelLimitAds)
          // } else if (item.SourceRange === 2) {
          //   item.SourceLimits = item.shieldAdsLimit
          // }
          // 删除定投广告位后端不关心参数
          item.SourceLimits = item.SourceLimits.map(item => {
            let obj = {};
            for (let key in item) {
              if (
                key === "SourceId" ||
                key === "BeginHour" ||
                key === "EndHour" ||
                key === "LimitType" ||
                key === "LimitQty"
              ) {
                obj[key] = item[key];
              }
            }
            // 如果为空传-1
            if (
              typeof item.LimitQty === "string" &&
              item.LimitQty.trim() === ""
            ) {
              obj.LimitQty = -1;
            }
            return obj;
          });

          // 删除策略不关心的广告位操作数据
          delete item.allAdsLimit;
          delete item.shieldAdsLimit;
          delete item.sourceAdsLimit;
          // 定投广告位转字符串
          item.SourceLimits = JSON.stringify(item.SourceLimits);
        }
        // 转回后端想要数据格式
        data.Materials.map(item => {
          item.OpenState = item.OpenState ? 1 : 0;
        });
        if (allAdsLimitData.length > maxLimit) {
          this.errorMessge(
            `所有策略广告位小时限流最多不能超过${maxLimit}条，当前共有${
              allAdsLimitData.length
              }条`
          );
          return;
        }
        // 开启按钮禁用
        this.saveBtnDisabled = true;
        // 发送请求
        savePutOn(data)
          .then(res => {
            // 编辑或保存成功
            if (res.status === 1) {
              // 显示成功通知
              this.$notify({
                title: "成功",
                message: "计划保存成功，正在为您跳转～",
                type: "success"
              });
              // 跳转列表页
              setTimeout(() => {
                location.href = "/iad_puton/planlist";
              }, 500);
            } else {
              if (res === 404) {
                // 未登录
                this.warnNotify("您未登录或登录已失效，请重新登录！");
              } else if (res === 403) {
                // 没有权限
                this.warnNotify("您没有权限操作，请联系管理员开通权限！");
              } else {
                // 其他错误
                this.warnNotify(res.message);
              }
              // 关闭按钮禁用
              this.saveBtnDisabled = false;
            }
          })
          .catch(err => {
            // 关闭按钮禁用
            this.saveBtnDisabled = false;
          });
      }
    },
    created() {
      // 初始化策略
      this.initStrategy();
      document.title = "投放明细";
    },
    mounted() {
    }
  };
</script>
<style>
  .navbar {
    min-height: none;
    max-height: 50px;
  }

  ul.nav {
    padding: 0 !important;
  }

  #navbar .sign-in-wrap {
    padding-right: 50px !important;
  }

  .launchTime .el-date-editor .el-range-separator {
    width: 10% !important;
  }

  #edui1_iframeholder {
    max-height: 177px !important;
    overflow: auto !important;
  }

  .money-icon {
    margin-right: 5px !important;
  }

  .areaWindow .el-dialog {
    width: 940px !important;
    margin-top: 4vh !important;
  }

  .areaWindow .el-dialog__body {
    padding: 8px 32px 75px !important;
  }

  .putonArea .region {
    margin-top: 4px !important;
  }

  .putonArea .region .provinces-group {
    width: 650px !important;
  }

  .putonArea .region .provinces-group .provinces {
    border: 1px solid transparent;
  }

  .putonArea .region .provinces-group .provinces .cities-group {
    max-height: 150px !important;
    font-size: 14px !important;
    border: 1px solid #ccc !important;
    border-left: none !important;
  }

  .putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
    border-right: none !important;
    border-bottom: none !important;
  }

  .el-select-dropdown__wrap {
    margin-right: -71px !important;
  }
</style>
<style
  lang="scss"
  scoped>
  @import "../../common/scss/color.scss";

  .content-wrapper {
    font-size: 14px;
    .banxin {
      width: 1310px;
      margin: 0 auto;
    }
    .content-wrapper-body {
      /*padding: 0 20px;*/
      .page-title {
        font-weight: 400;
        color: $mainColor;
        text-align: center;
      }
      .form-group {
        padding: 12px 0;
        max-width: 1300px;
        .form-inline {
          & + .form-inline {
            margin-top: 12px;
          }
          display: flex;
          justify-content: space-around;
          line-height: 34px;
          .form-item {
            width: 366px;
            .label {
              display: inline-block;
              font-size: 14px;
              color: #333;
              padding-right: 4px;
              width: 87px;
              text-align: right;
            }
            .el-input__inner,
            .el-select,
            .el-autocomplete,
            .el-input {
              width: 266px;
              height: 34px;
            }
            .el-checkbox-group {
              width: 243px;
              display: inline-block;
            }
            .el-checkbox + .el-checkbox {
              margin-left: 17px;
            }
            .el-checkbox__label {
              padding-left: 6px;
            }
            .el-radio + .el-radio {
              margin-left: 8px;
            }
            .content-wrapper {
              height: 406px;
              &.strategy {
                width: 516px;
              }
              &.rich-text {
                width: 716px;
                .important-declare {
                  width: 100%;
                  margin-top: 10px;
                  textarea {
                    padding: 8px 12px;
                    box-sizing: border-box;
                    font-size: 14px;
                    width: 100%;
                    border: 1px solid $borderColor;
                    border-radius: 4px;
                    height: 152px;
                  }
                }
              }
            }
            &.require .label::before {
              content: "*";
              color: red;
            }
            &.money-item {
              position: relative;
              .money-icon {
                color: #666;
                width: 34px;
                text-align: center;
                height: 34px;
                border-left: 1px solid $borderColor;
                position: absolute;
                right: 0;
                top: 0;
                font-size: 18px;
              }
            }
          }
        }
      }
      .limit-config {
        border: 1px solid $borderColor;
        .el-button--small,
        .el-button--small.is-round {
          padding: 10px 10px;
        }
        .data-header {
          background-color: #f8f9fa;
          border-bottom: 1px solid $borderColor;
        }
        .data-body {
          height: 242px;
          overflow-y: auto;
        }
        .data-inline {
          display: flex;
          justify-content: space-around;
          height: 48px;
          line-height: 48px;
          .item1 {
            width: 429px;
            text-align: center;
            &.tHeader {
              position: relative;
              .btnWeek {
                display: inline-block;
                height: 48px;
                width: 80px;
                cursor: pointer;
                &:hover {
                  color: $mainColor;
                  .week-item {
                    color: #333;
                  }
                }
              }
              .week-group {
                position: absolute;
                margin: auto;
                top: 48px;
                left: 0;
                right: 0;
                width: 66%;
                background-color: #fff;
                border: 1px solid $borderColor;
                display: flex;
                flex-wrap: wrap;
                box-shadow: 0 0 18px #ccc;
                padding: 4px 7px;
                .week-item {
                  cursor: pointer;
                  width: 70px;
                  height: 34px;
                  line-height: 34px;
                  border-radius: 50%;
                  &.active {
                    background-color: $mainColor;
                    color: #fff;
                  }
                }
              }
            }
            .el-button.active {
              background-color: $mainColor;
              color: #fff;
            }
          }
          .item2 {
            width: 271px;
            text-align: center;
          }
          .item3 {
            width: 165px;
            text-align: center;
          }
          .item4 {
            width: 126px;
            text-align: center;
            &.skew {
              position: relative;
              right: 9px;
            }
          }
          .item5 {
            width: 61px;
            text-align: center;
            &.skew {
              position: relative;
              right: 15px;
            }
            i {
              font-size: 20px;
              cursor: pointer;
            }
          }
        }
      }
      .basic-info {
        width: 100%;
      }
      .stratergy-group {
        margin-top: 50px;
        position: relative;
        max-width: 1300px;
        .add-strategy {
          cursor: pointer;
          position: absolute;
          text-align: center;
          right: 34px;
          top: -32px;
          font-size: 16px;
          background-color: $mainColor;
          color: #fff;
          width: 104px;
          height: 32px;
          line-height: 32px;
        }
      }
      .ads-config {
        margin-top: 40px;
        margin-bottom: 30px;
        width: 1270px;
        .ads-config-item {
          width: 100%;
          border: 1px solid $borderColor;
          position: relative;
          .leftTopTag {
            position: absolute;
            width: 103px;
            height: 35px;
            text-align: center;
            line-height: 36px;
            color: #333;
            border: 1px solid $borderColor;
            border-bottom-color: transparent;
            background-color: #fff;
            border-radius: 6px 6px 0 0;
            left: -1px;
            top: -36px;
          }
        }
        .search-part {
          width: 100% !important;
          height: 35px;
          padding: 16px;
          border-bottom: 1px solid $borderColor;
          .el-button {
            width: 96px;
            background-color: $mainColor;
          }
        }
        .list-part {
          .list-item {
            text-align: center;
            &.item1 {
              width: 102px;
            }
            &.item2 {
              width: 211px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &.item3 {
              width: 126px;
            }
            &.item4 {
              width: 122px;
              &.skew {
                position: relative;
                right: 17px;
              }
              i {
                font-size: 20px;
                cursor: pointer;
              }
            }
          }
          .list-header {
            display: flex;
            justify-content: space-between;
            background-color: #f8f9fa;
            height: 39px;
            line-height: 39px;
            border-bottom: 1px solid $borderColor;
          }
          .list-body {
            height: 200px;
            overflow-y: auto;
            .list-tr {
              text-align: center;
              display: flex;
              justify-content: space-between;
              height: 39px;
              line-height: 39px;
              .item3 {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    width: 263px;
    margin: 46px auto;
    .el-button {
      width: 122px;
      height: 44px;
    }
  }

  .info {
    border-radius: 10px;
    line-height: 20px;
    padding: 10px;
    margin: 10px;
    background-color: #ffffff;
  }

  .addStrategy {
    width: 1200px;
    margin: 0 auto;
    .el-dialog {
      width: 36%;
    }
  }

  .ads-sheild {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 2000;
    .ads-frame {
      position: fixed;
      margin: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 700px;
      height: 580px;
      background-color: white;
      .frame-header {
        width: 100%;
        height: 45px;
        background-color: #5898d7;
        position: absolute;
        .search-box {
          width: 192px;
          height: 26px;
          position: absolute;
          margin: auto;
          top: 0;
          bottom: 0;
          left: 420px;
          background-color: cyan;
          border-radius: 14px;
          .icon {
            position: absolute;
            top: 3px;
            left: 9px;
            color: #888;
            font-size: 18px;
          }
          .clear {
            position: absolute;
            top: 6px;
            right: 12px;
            color: #aaa;
          }
        }
        span {
          position: absolute;
          right: 20px;
          top: 14px;
          font-size: 18px;
          color: white;
          cursor: pointer;
        }
        h4 {
          line-height: 45px;
          margin: 0;
          color: white;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
        }
      }
    }
    #search-frame {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      border-radius: 14px;
      padding-left: 30px;
    }
    .ads-frame .frame-body {
      margin-top: 45px;
      height: 492px;
      padding: 16px 0 0 42px;
      ul {
        overflow: auto;
        height: 88%;
        li {
          float: left;
          margin-right: 29px;
          margin-bottom: 16px;
          &:nth-child(4n) {
            margin-right: 0;
          }
          .btn {
            padding: 0 10px;
            border: 1px solid #aaa;
            border-radius: 6px;
            cursor: pointer;
            width: 129px;
            height: 40px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &.selected {
              background-color: $mainColor;
              color: #fff;
            }
          }
        }
      }
    }
  }

  .ads-frame .frame-footer {
    width: 100%;
    height: 75px;
    position: absolute;
    bottom: 0;
    .btn-box {
      margin: 12px auto;
      width: 240px;
      display: flex;
      justify-content: space-between;
      .el-button {
        width: 110px;
      }
    }
  }

  .adsW-enter,
  .adsW-leave-to {
    opacity: 0;
  }

  .adsW-enter-active,
  .adsW-leave-active {
    transition: all 0.4s ease;
  }

  .weekGroup-enter,
  .weekGroup-leave-to {
    opacity: 0;
  }

  .weekGroup-enter-active,
  .weekGroup-leave-active {
    transition: all 0.4s ease;
  }

  .custom-label {
    position: absolute;
    left: 20px;
    bottom: 20px;
    line-height: 40px;
    font-size: 16px;
    color: #5798d7;
    cursor: pointer;
  }

  .import-ad {
    display: inline-block;
    position: relative;
    margin-left: 12px;
    input[type="file"] {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }

  .cancel-mrginb {
    margin-bottom: 0;
  }

  // 限流设置
  .zn-limit-time {
    margin-top: 20px;
    border: 1px solid $borderColor;
    .search-pad {
      padding: 16px;
    }
    .limit-search-inp {
      display: inline-block;
      width: 224px;
      margin-right: 32px;
    }
    .ads-config {
      margin-top: 0 !important;
    }
  }

  // 广告位限流设置弹窗
  .zn-limit-time-dialog {
    .limit-hour-head {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background-color: rgb(242, 242, 242);
      overflow: hidden;
    }
    .limit-hour-body {
      max-height: 352px;
      overflow-y: auto;
      .limit-hour-row {
        line-height: 34px;
        padding: 10px 0 0;
        text-align: center;
        overflow: hidden;
      }
    }
    .item {
      float: left;
    }
    // 时间段设置
    .ad-hour {
      width: 30%;
      text-align: center;
      .el-select {
        width: 40% !important;
      }
    }
    // 限流类型
    .limit-type {
      width: 35%;
      .el-select {
        width: 50% !important;
      }
    }
    // 数值
    .limit-number {
      width: 20%;
      .el-input {
        width: 80%;
      }
    }
    // 操作
    .limit-operation {
      width: 15%;
      i {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/edit-plan/edit-MPPlan.vue